/** @flow */
import tooltipsTranslations from "@modules/service/tooltips-translations";

export const serviceMessages = {
  en: {
    DRAFT_CREATED: "Draft was successfully created",
    DRAFT_UPDATED: "Draft was successfully updated",
    DRAFT_SUBMITTED: "Draft was submitted for review successfully",
    DRAFT_DISCARDED: "Draft was discarded successfully",
    DRAFT_CANCELED: "Draft was cancelled successfully",
    DRAFT_CANCELED_AND_DISCARDED: "Draft was cancelled and discarded successfully",
    ABSENCE_REASON_CREATED: "Absence Reason was created successfully",
    ALERT_ATTACHMENT_ADDED: "Alert attachment added successfully",
    ALERT_ATTACHMENT_REMOVED: "Alert attachment removed successfully",
    PENDING_REVIEW_APPROVED: "Pending Review was successfully approved",
    PENDING_REVIEW_BLOCED: "Pending Review was successfully blocked",
    PENDING_REVIEW_DEFFERED: "Pending Review was successfully deferred",
    DEPARTMENT_SCRIPT_CREATED: "Department Specific Script was created successfully",
    HIERARCHY_SCOPE_UPDATED: "Hierarchy scope was updated successfully",
    DYNAMIC_QUESTION_CREATED: "Dynamic Question was created successfully",
    EMAIL_CONTROL_SETTINGS_UPDATED: "Email Controls Settings successfully updated",
    EMAIL_NOTIFICATION_CREATED: "Email notification was successfully created",
    EMAIL_NOTIFICATION_UPDATED: "Email notification was successfully updated",
    EMAIL_NOTIFICATION_REMOVED: "Email notification was successfully removed",
    EMPLOYEE_IDENTITY_SETTINGS_UPDATED: "Employee Identity Settings successfully updated",
    SMS_WELLNESS_PROMPT_CREATED: "SMS Wellness Prompt was successfully created",
    SMS_WELLNESS_PROMPT_UPDATED: "SMS Wellness Prompt was successfully updated",
    SMS_WELLNESS_PROMPT_REMOVED: "SMS Wellness Prompt was successfully removed",
    EMPLOYEE_SMS_SETTINGS_UPDATED: "Employee SMS notifications successfully updated",
    SECURITY_SETTINGS_UPDATED: "The security setting were updated.",
    STAFF_GROUP_ADDED: "Staff Group was successfully added",
    STAFF_GROUP_UPDATED: "Staff Group was successfully updated",
    STAFF_GROUP_ENABLED: "Staff Group was successfully enabled",
    STAFF_GROUP_SAVED: "Staff Group Configuration was successfully saved",
    PAGER_RESTRICTION_CREATED: "Pager restriction was successfully created",
    PAGER_RESTRICTION_UPDATED: "Staff Group Configuration was successfully updated",
    PAGER_RESTRICTION_DELETED: "Staff Group Configuration was successfully deleted",
    SMS_RESTRICTION_CREATED: "SMS restriction was successfully created",
    SMS_RESTRICTION_UPDATED: "SMS restriction was successfully updated",
    SMS_RESTRICTION_DELETED: "SMS restriction was successfully deleted",
    REPORTING_PARAMETERS_UPDATED: "Reporting Parameters were successfully updated",
    EXCLUDED_REASON_CREATED: "Reason to be excluded was successfully created",
    EXCLUDED_REASON_UPDATED: "Reason to be excluded was successfully updated",
    EXCLUDED_REASON_DELETED: "Reason to be excluded was successfully deleted",
    SELECTED_EXCLUDED_REASONS_DELETED: "Selected reasons to be excluded were successfully deleted",
    RTW_ATTACHMENT_ADDED: "Rtw attachment added successfully",
    RTW_ATTACHMENT_REMOVED: "Rtw attachment removed successfully",
    SERVICE_SETTINGS_UPDATED: "Service Settings successfully updated",
    CHANGE_SET_DELETED: "Change set was successfully deleted",
    SELECTED_CHANGE_SETS_DELETED: "Selected change sets were successfully deleted",
    SHIFT_CREATED: "Shift was successfully created",
    SHIFT_UPDATED: "Shift was successfully updated",
    CUSTOM_CONTACT_CREATED: "Custom special contact type was successfully created",
    CUSTOM_CONTACT_UPDATED: "Custom special contact type was successfully updated",
    CUSTOM_CONTACT_REMOVED: "Custom special contact type was successfully removed",
    SPECIAL_CONTACT_CREATED: "Special contact was successfully created",
    SPECIAL_CONTACT_UPDATED: "Special contact was successfully updated",
    SPECIAL_CONTACT_REMOVED: "Special contact was successfully removed",
    STANDART_QUESTION_CREATED: "Standard Question was created successfully",
    SYSTEM_SETTINGS_UPDATED: "System Settings successfully updated",
    BULK_REGISTRATION_EMAILS_SENT: "Bulk Registration Emails were successfully sent",
    EMPLOYEE_EMAILS_SENT: "Employee Emails were successfully sent",
    REGISTRATION_EMAILS_UPDATED: "Registration emails successfully updated",
    SUCCESSFULLY_REASSIGNED: "Successfully reassigned!",
    SUCCESSFULLY_UNASSIGNED: "Successfully unassigned!",
    UPLOAD_LOGO_SUCCESS: "Logo was successfully uploaded",
    USER_PERMISSIONS_UPDATED: "User permissions were successfully updated",
  },
};

export default {
  en: {
    ...tooltipsTranslations.en,
    ADD_ALERT: "Add Alert",
    ABSENCE_REASONS: "Absence Reasons",
    ADDED_BY: "Added By",
    CANCEL: "Cancel",
    DATE_CREATED: "Date Created",
    DATE_ADDED: "Date Added",
    DURATION: "Duration",
    EDIT: "Edit",
    DELETE: "Delete",
    EDIT_LIVE: "Edit Live",
    EMPLOYEE_USE: "Employee Use",
    EXISTING_SHIFT_PATTERN: "Existing Shift Patterns",
    PLANNED_LEAVE: "Planned Leave",
    REPORTING_PARAMETERS: "Reporting Parameters",
    SCHEDULED_REPORTS_TUTORIAL: "Scheduled Reports Tutorial",
    SERVICE_CONFIGURATION: "Service Configuration",
    PLANNED_LEAVE_TASKS: "Planned Leave Tasks",
    ADD_NEW_TASK: "Add New Task",
    LEAVE_TYPE: "Leave Type",
    PLANNED_LEAVE_CONFIGURATION: "Planned Leave Configuration",
    ADD_NEW_NURSE_DECLINED_REASON: "Add New Nurse Declined Reason",
    ENTER_A_NEW_NURSE_DECLINED_REASON: "Enter a new Nurse Declined Reason",
    DISABLE_REASON: "Disable Reason",
    ADD_NEW_REASON: "Add New Reason",
    ADD_REASON: "Add Reason",
    ADD_OUTCOME: "Add Outcome",
    NON_MEDICAL_ABSENCE: "Non-Medical Absence",
    ABSENCE_REASON_CLASSIFICATIONS: "Absence Reason Classifications",
    ADD_NEW_ABSENCE_REASON: "Add New Absence Reason",
    ABSENCE_TYPE: "Absence Type",
    STATUS: "Status",
    ACTIONS: "Actions",
    YES: "Yes",
    NO: "No",
    UPDATE: "Update",
    DISABLE: "Disable",
    NOT_REQUIRED: "-",
    DRAFT: "Draft",
    LIVE: "Live",
    PARENT_REASON: "Parent Reason",
    NURSE_TRANSFER_ELIGIBILITY: "Nurse Transfer Eligibility",
    DISPLAY_NAME: "Display Name",
    TASK_DESCRIPTION: "Task Description",
    KPI_TARGET: "KPI Target",
    KPI_TARGET_DAYS: "KPI Target (Days)",
    KPI_TARGET_HOURS: "KPI Target (Hours)",
    EFFECTIVE_FROM: "Effective From",
    EFFECTIVE_TO: "Effective To",
    INVALID_DATE: "Invalid Date",
    GENERAL: "General",
    SPECIFIC_REASONS: "Specific Reasons",
    SECURITY: "Security",
    SYSTEM_ACCESS: "System Access",
    CALL_FLOW: "Call Flow",
    STANDARD_SCRIPTS: "Standard Scripts",
    STANDARD_QUESTIONS: "Standard Questions",
    STANDARD_QUESTIONS_TOOLTIP:
      "Standard questions form part of an absence interaction. They are asked of the employee by our advisor at specific junctions within the overall call flow, and are intended to facilitate the capture of vital additional information relevant to the absence itself. By nature, standard questions are not customisable (in the sense that the purpose and functioning of the question cannot be made bespoke), however, certain aspects of a standard question are easily updated by selecting the 'Edit' button. Draft changes can be saved and, when ready, submitted for approval by a GoodShape representative.  Note, it is not possible to implement a change if a pending change request is already in process.",
    DYNAMIC_QUESTIONS: "Dynamic Questions",
    CALL_FLOW_QUESTIONS: "Call flow Questions",
    SIMULATE_QUESTIONS: "Simulate Questions",
    ALERTS_AND_NOTIFICATIONS: "Alerts & Notifications",
    MANAGER_SMS: "SMS Notifications",
    PROCESSES: "Processes",
    SERVICE_SUMMARY: "Service Summary",
    ALWAYS: "Always",
    NEVER: "Never",
    ABSENCE_DURATION_DEPENDENT: "Absence duration dependent",
    SEARCH_BY_SURNAME: "Search by Surname",
    ABSENCE_REASON_ADD_SUCCESS: "Abasence reason was successfully added",
    ABSENCE_REASON_EDIT_SUCCESS: "Abasence reason was successfully updated",
    HOME_MOBILE: "Phone Number",
    EMPLOYEE_REF_PRIMARY: "Employee Ref",
    COMMITTED_VALUES_AFTER_MIDNIGHT:
      "This record has committed values that will take effect from midnight.",
    SEARCH_EMPLOYEE_BY_SURNAME: "Search Employee by Surname",

    // SERVICE SETTINGS
    SERVICE_SETTINGS: "Service Settings",
    SERVICE_SETTINGS_DRAFT: "Draft for Service Settings",
    SERVICE_SETTINGS_LOCKED: "This draft is locked and cannot be edited as it is pending review.",
    SERVICE_SETTINGS_LAST_UPDATED_BY: "Last edited by:",
    SERVICE_SETTINGS_START_DRAFT: "Start Draft",
    SERVICE_SETTINGS_SUBMIT_CHANGES: "Submit Changes",
    SERVICE_SETTINGS_SAVE: "Save",
    SERVICE_SETTINGS_MAIN_SETTINGS: "Main Settings",
    SERVICE_SETTINGS_ABSENCE_TYPE: "Absence Type",
    SERVICE_SETTINGS_MINIMUM_ABSENCE: "Minimum Absence (minutes)",
    SERVICE_SETTINGS_MINIMUM_ABSENCE_DURATION: "Minimum Absence Duration (minutes)",
    SERVICE_SETTINGS_TIME_IN_ADVANCE_ABSENCES_CAN_CLOSE:
      "Time in Advance Absences Can Close (Hours)",
    SERVICE_SETTINGS_ABSENCE_RECORDING_UNITS: "Absence Recording Units",
    SERVICE_SETTINGS_INCLUDE_FIT_DATE_CAPTURE: "Include Fit Date Capture",
    SERVICE_SETTINGS_RTW_DISCUSSION_TYPE: "RTW Discussion Type",
    SERVICE_SETTINGS_ALLOW_EMPLOYEES_TO_REOPEN_ABSENCES: "Allow Employees to Re-Open Absences",
    SERVICE_SETTINGS_TIME_PERIOD_IN_WHICH_ABSENCES_CAN_BE_REOPENED:
      "Time period in which absences can be re-opened (Calendar Days)",
    SERVICE_SETTINGS_TIME_IN_ADVANCE_AN_ABSENCE_CAN_BE_OPENED:
      "Time in advance an absence can be opened (Calendar Days)",
    SERVICE_SETTINGS_CAPTURE_ABSENCE_ON_BANK_HOLIDAYS: "Capture Absence on Bank Holidays",
    SERVICE_SETTINGS_PHASED_RTW_DAYS_RECORDING: "Phased RTW days recording?",
    SERVICE_SETTINGS_TASK_KPIS_EXCLUDE_BANK_HOLIDAYS: "Task KPI's Exclude Bank Holidays",
    SERVICE_SETTINGS_TASK_KPIS_EXCLUDE_WEEKENDS: "Task KPI's Exclude Weekends",
    SERVICE_SETTINGS_NON_MEDICAL_ABSENCE: "Non-Medical Absence",
    IMPORTANT_ANNOUNCEMENT: "Important Announcement",
    IMPORTANT_REMINDER: "Important Reminder",
    SERVICE_SETTINGS_NON_MEDICAL_ABSENCE_EMPTY: "Non-Medical Script",
    SERVICE_SETTINGS_ALLOW_EMPLOYEES_OPEN_CLOSE_ABSENCE_IN_SAME_CALL_INTERACTION:
      "Allow employees to open and close absences in same interaction?",
    SERVICE_SETTINGS_ALLOW_EMPLOYEES_UPDATE_CLOSE_ABSENCE_IN_SAME_CALL_INTERACTION:
      "Allow employees to update and close absences in same interaction?",

    // EMAIL NOTIFICATIONS
    EMAIL_NOTIFICATIONS: "Email Notifications",
    EMAIL_ABSENCE_NOTIFICATIONS: "Email Absence Notification",
    EMAIL_NOTIFICATION_PROFILE: "Email Notification Profile #{id}",
    EMAIL_NOTIFICATION_PROFILE_ID: "Profile ID",
    EMAIL_NOTIFICATION_PROFILE_NAME: "Email Profile Name",
    EMAIL_NOTIFICATION_HIIERARCHY_SCOPE: "Hierarchy Scope",
    HIERARCHY_SCOPE: "Hierarchy Scope",
    EMAIL_NOTIFICATION_DATE_ADDED: "Date Added",
    EMAIL_NOTIFICATION_ADDED_BY: "Added By",
    EMAIL_NOTIFICATION_STATUS: "Status",
    EMAIL_NOTIFICATION_ADD_PROFILE: "Add New Email Profile",
    EMAIL_NOTIFICATION_ADD_TITLE: "New Email Profile",
    EMAIL_NOTIFICATION_ADD_SUBMIT: "Add Email Profile",
    EMAIL_NOTIFICATION_EDIT_SUBMIT: "Save",
    EMAIL_NOTIFICATION_EDIT_TITLE: "Email Notification Profile #{id}",
    EMAIL_NOTIFICATION_DELETE_TITLE: "Delete Email Profile",
    EMAIL_NOTIFICATION_DELETE_QUESTION: "Are you sure you want to delete email profile {id}?",
    EMAIL_NOTIFICATION_DELETE_SUBMIT_TEXT: "Delete Profile",
    EMAIL_NOTIFICATION_STEP1: "Content",
    EMAIL_NOTIFICATION_STEP1_MAIN_DETAILS: "Main Details",
    EMAIL_NOTIFICATION_STEP1_EMAIL_INFO: "Info to Be Included in Email Notification",
    EMAIL_NOTIFICATION_STEP1_DEFAULT_INSTRUCTIONS: "Default Instructions",
    EMAIL_NOTIFICATION_STEP1_NEXT_BUTTON: "Next Reason Specific Instructions",
    EMAIL_NOTIFICATION_STEP2: "Reason Specific Instructions",
    EMAIL_NOTIFICATION_STEP2_NEXT_BUTTON: "Next Distribution Rules",
    EMAIL_NOTIFICATION_STEP3: "Distribution Rules",
    EMAIL_NOTIFICATION_STEP4: "Hierarchy Scope",
    EMAIL_NOTIFICATION_STEP3_NEXT_BUTTON: "Next Hierachy Scope",
    EMAIL_NOTIFICATION_EMAIL_DISTRIBUTION_NAME: "Name",
    EMAIL_NOTIFICATION_REASON: "Reason",
    EMAIL_NOTIFICATION_ABSENCE_REASON: "Absence Reason",
    EMAIL_NOTIFICATION_INSTRUCTION_TEXT: "Instruction Text",
    EMAIL_NOTIFICATION_LAST_UPDATED: "Last Updated",
    EMAIL_NOTIFICATION_LAST_UPDATED_BY_TEXT: "Update {date} By {name}",
    EMAIL_NOTIFICATION_EMAIL_DISTRIBUTION_TYPE: "Email Distribution Type",
    EMAIL_NOTIFICATION_STARTS_NOTIFICATIONS: "Start Notifications",
    EMAIL_NOTIFICATION_BATCH_FREQUENCY: "Batch Frequency",
    EMAIL_NOTIFICATION_HIERARCHY_SCOPE: "Hierarchy Scope",
    EMAIL_NOTIFICATIONS_SECTION_EMPTY: "This section has not been completed yet.",
    AFTER_EVERY_ABSENCE: "After Every Absence",
    INCLUDE_RTW_DETAILS_IN_NOTIFICATIONS: "Include RTW Details in Absence Notifications",
    INCLUDE_ALERTS_IN_NOTIFICATIONS: "Include Alerts In Absence Notifications",

    // MANAGER SMS PAGER NOTIFICATIONS
    MANAGER_SMS_PAGER_NOTIFICATION_RULE_TITLE: "Manager SMS Notifications",
    MANAGER_SMS_PAGER_NOTIFICATION_RULE_ADD_TITLE: "New {type} Rule",
    MANAGER_SMS_PAGER_NOTIFICATION_RULE_ADD_STEP_1_NEXT_BUTTON: "Next: Hierarchy Area",
    MANAGER_SMS_PAGER_NOTIFICATION_RULE_EDIT_TITLE: "Edit {type} Rule",
    MANAGER_SMS_PAGER_NOTIFICATION_RULE_DELETE_TITLE: "Delete {type} Rule",
    MANAGER_SMS_PAGER_NOTIFICATION_RULE_DELETE_QUESTION:
      "Are you sure you want to delete {type} {id}?",
    MANAGER_SMS_PAGER_NOTIFICATION_RULE_DELETE_SUBMIT_TEXT: "Delete {type} Rule",

    MANAGER_SMS_NOTIFICATIONS_MODAL_ADD_TITLE: "New {type} Rule",
    MANAGER_SMS_NOTIFICATIONS_MODAL_EDIT_TITLE: "{type} Rule {id}",
    MANAGER_SMS_NOTIFICATIONS_MODAL_STEP1_TITLE: "Main Details",
    MANAGER_SMS_NOTIFICATIONS_MODAL_NEXT_BUTTON_TEXT: "Next: Hierarchy Areas",
    MANAGER_SMS_NOTIFICATIONS_MODAL_STEP2_TITLE: "Hierarchy Areas",
    MANAGER_SMS_NOTIFICATIONS_MODAL_ADD_BUTTON: "Add {type} Rule",
    MANAGER_SMS_NOTIFICATIONS_MODAL_EDIT_BUTTON: "Save {type} Rule",

    MANAGER_SMS_NOTIFICATIONS_TITLE: "SMS Absence Notifications",
    MANAGER_SMS_NOTIFICATIONS_ADD_BUTTON: "Add New SMS Rule",
    MANAGER_SMS_NOTIFICATIONS_ENABLED_TEXT: "SMS Notifications Enabled",
    MANAGER_SMS_NOTIFICATIONS_DISABLED_TEXT: "SMS Notifications Disabled",
    MANAGER_SMS_NOTIFICATIONS_RULE_ID: "Rule ID",
    MANAGER_SMS_NOTIFICATIONS_START_TIME: "SMS Start Time",
    MANAGER_SMS_NOTIFICATIONS_END_TIME: "SMS End Time",
    MANAGER_SMS_NOTIFICATIONS_INCLUDE_EMPLOYEE_REF: "Include Employee Ref",
    MANAGER_SMS_NOTIFICATIONS_INCLUDE: "Include",
    MANAGER_SMS_NOTIFICATIONS_DO_NOT_INCLUDE: "Do Not Include",
    MANAGER_SMS_HIERARCHY_AREAS: "Hierarchy Areas",
    MANAGER_SMS_DATE_ADDED: "Date Added",

    MANAGER_PAGER_NOTIFICATIONS_TITLE: "Pager Notifications",
    MANAGER_PAGER_NOTIFICATIONS_ADD_BUTTON: "Add New Pager Rule",
    MANAGER_PAGER_NOTIFICATIONS_ENABLED_TEXT: "Pager Notifications Enabled",
    MANAGER_PAGER_NOTIFICATIONS_DISABLED_TEXT: "Pager Notifications Disabled",
    MANAGER_PAGER_NOTIFICATIONS_RULE_ID: "Rule ID",
    MANAGER_PAGER_NOTIFICATIONS_START_TIME: "Pager Start Time",
    MANAGER_PAGER_NOTIFICATIONS_END_TIME: "Pager End Time",
    MANAGER_PAGER_HIERARCHY_AREAS: "Hierarchy Areas",
    MANAGER_PAGER_DATE_ADDED: "Date Added",

    MANAGER_SUCCESS_NOTIFICATION_MESSAGE: "{type} notifications successfully updated",
    MANAGER_TYPE_PAGER: "Pager",
    MANAGER_TYPE_SMS: "SMS",

    // EMPLOYEE SMS NOTIFICATIONS
    EMPLOYEE_SMS_NOTIFICATION_RULE_TITLE: "Employee SMS Notifications",
    EMPLOYEE_SMS_RULES_TITLE: "Employee SMS Rules",
    EMPLOYEE_SMS_OVERDUE_REMINDERS_SWITCH: "Overdue Absence Reminders {status}",
    EMPLOYEE_SMS_TEXT_TO_CLOSE_SWITCH: "Text To Close {status}",

    EMPLOYEE_SMS_WELLBEING_PROMPTS_TITLE: "SMS Wellbeing Prompts",
    EMPLOYEE_SMS_WELLBEING_ADD_PROMPT: "Add New Text Prompt",
    EMPLOYEE_SMS_WELLBEING_ABSENCE_REASON: "Absence Reason",
    EMPLOYEE_SMS_WELLBEING_TEXT_MESSAGE: "Text Message",
    EMPLOYEE_SMS_WELLBEING_SENT_ON_OPEN: "Sent On Open",
    EMPLOYEE_SMS_WELLBEING_SENT_ON_UPDATE: "Sent On Update",
    EMPLOYEE_SMS_WELLBEING_SENT_ON_CLOSE: "Sent On Close",
    EMPLOYEE_SMS_WELLBEING_DATE_ADDED: "Date Added",
    EMPLOYEE_SMS_WELLBEING_STATUS: "Status",

    EMPLOYEE_SMS_MODAL_ADD_TITLE: "New Employee Text Prompt",
    EMPLOYEE_SMS_MODAL_EDIT_TITLE: "Edit Employee Text Prompt {id}",
    EMPLOYEE_SMS_MODAL_STEP1_TITLE: "Main Details",
    EMPLOYEE_SMS_MODAL_NEXT_BUTTON_TEXT: "Next: Hierarchy Areas",
    EMPLOYEE_SMS_MODAL_STEP2_TITLE: "Hierarchy Areas",
    EMPLOYEE_SMS_MODAL_ADD_BUTTON: "Add Employee Prompt",
    EMPLOYEE_SMS_MODAL_EDIT_BUTTON: "Save Employee Prompt",
    EMPLOYEE_SMS_DELETE_TITLE: "Delete Employee Text Prompt",
    EMPLOYEE_SMS_DELETE_QUESTION: "Are you sure you want to delete {id}?",
    EMPLOYEE_SMS_DELETE_SUBMIT_TEXT: "Delete Prompt",

    // SHIFT PATTERNS
    SHIFT_PATTERNS: "Shift Patterns",
    ACTIVE_SHIFT_PATTERNS: "Active Shift Patterns",
    EDIT_SHIFT_PATTERN: "Edit Shift Pattern",
    SHIFT_PATTERN_NAME: "Shift Pattern Name",
    SHIFT_PATTERN_EMPLOYEES: "Employees",
    SHIFT_PATTERN_DEPARTMENTS: "Departments",
    SHIFT_PATTERN_CONFIGURE: "Configure",
    SHIFT_PATTERN_SPECIFY_PATTERN: "Specify Pattern",
    SHIFT_PATTERN_DATE: "Date",
    SHIFT_PATTERN_DAY_TYPE: "Day Type",
    SHIFT_PATTERN_TIME_TO_WORK: "Time Due To Work",
    SHIFT_PATTERN_ADD_TITLE: "Add New Shift Pattern",
    SHIFT_PATTERN_ADD_STEP_1_NEXT_BUTTON: "Next: Specify Pattern",
    SHIFT_PATTERN_EDIT_TITLE: "Edit Shift Pattern",
    SHIFT_PATTERN_DELETE_TITLE: "Delete Shift Pattern",
    SHIFT_PATTERN_DELETE_QUESTION: "Are you sure you want to delete shift pattern {shiftName}?",
    SHIFT_PATTERN_DELETE_SUBMIT_TEXT: "Yes, Detele Shift Pattern",
    SHIFT_PATTERN_WORKING_DAY: "Working Day",
    SHIFT_PATTERN_NON_WORKING_DAY: "Non-Working Day",
    EMPLOYEES_FOR_PATTERN: "Employees for Pattern: {patternName}",
    DEPARTMENTS_FOR_PATTERN: "Departments for Pattern: {patternName}",
    UNASSIGN_SELECTED: "Unassign Selected",
    REASSIGN_SELECTED: "Reassign Selected",
    SHIFT_PATTERN_FIELD_LABEL_NAME: "Shift Pattern",
    UNASSIGN: "Unassign",
    REASSIGN_EMPLOYEES_FROM_SHIFT_PATTERN:
      "Reassign {employeesCount} employee from the {shiftPatternName} shift pattern to:",
    REASSIGN_EMPLOYEES_FROM_SHIFT_PATTERN_plural:
      "Reassign {employeesCount} employees from the {shiftPatternName} shift pattern to:",
    REASSIGN_DEPARTMENTS_FROM_SHIFT_PATTERN:
      "Reassign {departmentsCount} department from the {shiftPatternName} shift pattern to:",
    REASSIGN_DEPARTMENTS_FROM_SHIFT_PATTERN_plural:
      "Reassign {departmentsCount} departments from the {shiftPatternName} shift pattern to:",
    UNASSIGN_EMPLOYEES_FROM_SHIFT_PATTERN:
      "Are you sure you want to unassign {employeesCount} employee from the {shiftPatternName} shift pattern?",
    UNASSIGN_EMPLOYEES_FROM_SHIFT_PATTERN_plural:
      "Are you sure you want to unassign {employeesCount} employees from the {shiftPatternName} shift pattern?",
    UNASSIGN_DEPARTMENTS_FROM_SHIFT_PATTERN:
      "Are you sure you want to unassign {departmentsCount} department from the {shiftPatternName} shift pattern?",
    UNASSIGN_DEPARTMENTS_FROM_SHIFT_PATTERN_plural:
      "Are you sure you want to unassign {departmentsCount} departments from the {shiftPatternName} shift pattern?",
    REASSIGN_DEPARTMENTS: "Reassign Departments",
    SELECT_SHIFT_PATTERN: "Select Shift Pattern",
    UNASSIGN_EMPLOYEES: "Unassign Employees",
    UNASSIGN_DEPARTMENTS: "Unassign Departments",
    SOMEONE_ELSE_NEED_TO_BE_INFORMED: "Someone else need to be informed?",
    EXPORT_FULL_LIST: "Export Full List",
    WANT_TO_AUDIT_ALL_DEPARTMENT_CONTACTS: "Want to audit all Department Contacts?",

    // USER PERMISSIONS
    USER_PERMISSIONS: "User Permissions",
    MANAGEMENT_USERS: "Management Users",
    EMPLOYEE_USERS: "Employee Users",
    USERS: "Users",
    ABSENCE_UPDATE_PERMISSIONS: "Absence Update Permissions",
    NOTIFICATION_ADMIN: "Notification Admin",
    NO_PERMISSIONS: "No Permissions",
    BOTH: "Both",
    MEDICAL_ONLY: "Medical Only",
    NONE: "None",
    NON_MEDICAL_ONLY: "Non Medical Only",
    AUTHORISED_TO_MAKE_CHANGES: "Authorised To Make Changes",
    CAN_REQUEST_CHANGES: "Can Request Changes",
    EXCLUDING_ABSENCES_FROM_ALERTS: "Exclude Absences From Alerts",
    ALLOW_MANAGER_TO_EDIT_EMPLOYEES_SHIFT_PATTERN: "Allow Manager Edit Employees Shift Pattern",
    EMPLOYEE_ACCOUNTS_PERMITTED: "Employee Accounts",
    BENCHMARKING_STATISTICS: "Benchmarking Statistics",
    ABSENCE_MONITORING_DETAILS: "Absence Monitoring Details",
    VIEW_COMPLETED_RTW_INTERVIEWS: "View RTW Forms",
    REPORT_ABSENCES: "Report Absences",
    UPDATE_ABSENCES: "Update Absences",
    PERMITTED_EXTENSION: "Permitted Extension",
    DAYS: "Days",
    DAYS_AND_HOURS: "Days and hours",
    WEEKS: "Weeks",
    MONTHS: "Months",
    CLOSE_ABSENCES: "Close Absences",
    EMPLOYEE_LED: "Employee Led",
    NURSE_LED: "Nurse Led",
    USER_ACCOUNTS: "User Accounts",
    ACCOUNT_CREATED: "Account Created",
    LATEST_LOGIN: "Latest Login",
    REGISTERED: "Registered",

    // STAFF GROUPS
    STAFF_GROUP: "Staff Group",
    TYPE: "Type",
    NUMBER_OF_EMPLOYEES_ASSIGNED: "Number of Employees Assigned",
    REMOVE_THIS_ASSIGNMENT: "Remove This Assignment",
    REASSIGN_TO_NEW_GROUP: "Reassign To New Group",
    REASSIGN_STAFF_GROUP: "Reassign Staff Group",
    REASSIGN_EMPLOYEES: "Reassign Employees",
    REASSIGN: "Reassign",
    REASSIGN_EMPLOYEES_TO_STAFF_GROUP:
      "Reassign {employeesCount} employees from {staffGroupName} Staff Group to:",
    SELECT_NEW_STAFF_GROUP: "Select New Staff Group",
    STAFF_GROUPS_CONFIGURATION: "Staff Groups Configuration",
    STAFF_GROUPS: "Staff Groups",
    ADD_NEW_STAFF_GROUP: "Add New Staff Group",
    NEW_STAFF_GROUP: "New Staff Group",
    ADD_NEW_STAFF_TYPE: "Add New Staff Type",
    STAFF_GROUP_NAME: "Staff Group Name",
    STAFF_GROUP_TYPE: "Staff Group Type",
    DISABLE_STAFF_GROUP: "Disable Staff Group",
    ENABLE_STAFF_GROUP: "Enable Staff Group",
    EDIT_STAFF_GROUP: "Edit Staff Group",
    UPDATE_STAFF_GROUP: "Update Staff Group",
    SUBMIT_CHANGES: "Submit Changes",
    // DATA SECURITY
    EMPLOYEE_IDENTITY: "Employee Identity",
    EMPLOYEE_IDENTIFICATIONS: "Employee Identifications",
    DATA_SECURITY: "Data Security",
    PASSWORD_RESET_REQUIREMENTS: "Password Reset Requirements",
    IP_ADDRESS_RESTRICTION: "IP Address Restriction",
    ADD_NEW_IP_ADDRESS: "Add New IP Address",
    MFC_REGISTRATION_EMAILS: "GoodShapeCentral! Registration Emails",
    DISABLE_IP_ADDRESS: "Disable IP Address",
    RESTORE_IP_ADDRESS: "Restore IP Address",
    ADD_PERMITTED_IP_ADDRESS: "Add Permitted IP Address",
    ADD_IP_ADDRESS: "Add IP Address",
    SECURITY_QUESTIONS: "Security Questions",
    DATE_OF_BIRTH: "Date of Birth",
    EMPLOYEE_REF: "Employee Ref",
    LAST_NAME: "Last name",
    MOTHERS_MAIDEN_NAME: "Mothers maiden name",
    PHONE_NUMBER: "Phone Number",
    RESET_QUESTION: "Allow Question Reset",
    DO_NOT_PROCEED: "Do not proceed with call",
    PROCEED_AND_NOTE: "Proceed with Call, noting incorrect answer",
    NAME_OF_BIRTH_PLACE: "What is the name of the city or town you were born in?",
    NAME_OF_FIRST_SCHOOL: "What is the name of your first school?",
    NAME_OF_PET: "What is the name of your pet?",
    MOTHER_MAIDEN_NAME: "What is your mother's maiden name?",
    NAME_OF_FIRST_COMPANY: "What was the name of the first company you worked in?",
    PERMITTED_TO_CREATE_NEW_EMPLOYEE: "Permitted To Create New Employee Records",
    THIRD_PARTY_CONSENT_REQUIRED: "Third Party Consent",
    NOTIFICATION_AUDIT_ENABLED: "Notification Audit Enabled",
    AUDIT_FREQUENCY: "Audit Frequency Days",
    IDENTITY_VERIFICATION_CHECK: "Identity Verification Check",
    PERMITTED_TO_CREATE_NEW_EMPLOYEE_RECORDS: "Is the advisor permitted to create new employees?",
    PROCESS_FOR_FAILED_SECURITY_QUESTION: "Process For Failed Security Question",
    EMPLOYEE_ACCESS_AUDIT: "Employee Access Audit",
    NOTIFICATION_AUDIT: "Notification Audit",
    AUDIT_FREQUENCY_DAYS: "Audit Frequency (Days)",
    ENABLED_QUESTIONS: "Enabled Questions",
    SECURITY_QUESTIONS_ENABLED: "Security Questions Enabled",
    THIRD_PARTY_CONSENT:
      "Are third party callers allowed to agree an absence reason classification, and consent status, on the employee's behalf?",
    MINIMUM_ITEMS_MUST_BE_CHECKED: "Minimum {count} items must be checked!",
    MAXIMUM_ITEMS_MUST_BE_CHECKED: "Maximum {count} items must be checked!",
    DISABLE_STAFF_GROUP_WARNING:
      "Employees are assigned to the {staffGroupName} Staff Group. What would you like to happen to the Staff Group assignment of these employees?",
    ENABLE_DISABLED_STAFF_GROUP:
      "{staffGroupName}  Staff Group is disabled. Do you want to enable the Staff Group?",

    // MFC CONFIG
    MFC_CONFIG: "MFC Config",

    // EMAIL CONTROLS
    EMAIL_CONTROLS: "Email Controls",
    MARK_EMAIL_AS_PRIVATE: "Mark Email As Private",
    SUPPRESS_ALL_EMAIL_CONTENT: "Suppress All Email Content",
    ALLOW_HYPERLINKS_IN_INSTRUCTIONS: "Allow Hyperlinks In Instructions",
    MARK_EMAIL_AS_PRIVATE_DESCRIPTION:
      "If enabled, notifications will have a “Private” flag set on them. This means that delegates who have access to the notification recipient’s mailbox will not be able to see the email notification in the recipient mailbox. This is recommended to be enabled by default.",
    SUPPRESS_ALL_EMAIL_CONTENT_DESCRIPTION:
      "If enabled, no absence details will appear in absence notifications. Instead, the recipient will be directed to login to Insight to view details of the absence. This is recommended to be disabled by default.",
    ALLOW_HYPERLINKS_IN_INSTRUCTIONS_DESCRIPTION:
      "If enabled, users will be able to include hyperlinks to online webpages within the “Instructions to Manager” setting of an Email notification profile. This is recommended to be enabled by default.",
    EMAIL_CONTENT: "Email Content",
    EMAIL_DOMAINS: "Email Domains",
    EMAIL_DOMAIN: "Email Domain",
    EMAIL_DOMAIN_RESTRICTIONS: "Email Domain Restrictions",
    ADD_NEW_EMAIL_DOMAIN: "Add New Email Domain",
    RESTORE_EMAIL_DOMAIN: "Restore Email Domain",
    DISABLE_EMAIL_DOMAIN: "Disable Email Domain",
    ADD_APPROVED_EMAIL_DOMAIN: "Add Approved Email Domain",
    ADD_DOMAIN: "Add Domain",
    PERMITTED_EMAIL_DOMAIN: "Permitted Email Domain",
    DATE_DISABLED: "Date Disabled",
    SELECT: "Select",
    SUPRESS_ALL_EMAIL_CONTENT: "Supress all email content",
    ADD_EMAIL_DOMAIN: "Add Email Domain",
    EMAIL_DOMAIN_RESTRICTION_ENABLED: "Email Domain Restriction Enabled",
    EMAIL_DOMAIN_RESTRICTION_DISABLED: "Email Domain Restriction Disabled",

    // NURSE DECLINED REASONS
    NURSE_DECLINED_REASONS_APPROVABLE_TYPE: "Nurse Declined Reason",
    NURSE_DECLINED_REASONS: "Nurse Declined Reasons",
    NURSE_DECLINED_LOCKED_DEPENDENCIES:
      "This section is locked and cannot be edited due to a dependency.",
    NURSE_DECLINED_REASONS_ADD_REASON: "Add Reason Draft",
    DECLINED_REASON: "Declined Reason",
    NURSE_DECLINED_REASONS_ADD_REASON_FC: "Add Reason",
    NURSE_DECLINED_REASONS_LIVE_REASONS: "Live Reasons",
    NURSE_DECLINED_REASONS_LIVE_REASONS_FC: "Live Reasons",
    NURSE_DECLINED_REASONS_LIVE_REASONS_EMPTY: "No live reasons to review",
    NURSE_DECLINED_REASONS_LIVE_REASONS_EMPTY_FC: "No live reasons to review",
    NURSE_DECLINED_REASONS_PENDING_REVIEW: "Reasons Pending Review",
    NURSE_DECLINED_REASONS_PENDING_REVIEW_FC: "Reasons Drafts Awaiting Review",
    NURSE_DECLINED_REASONS_PENDING_REVIEW_EMPTY: "No draft reasons pending review",
    NURSE_DECLINED_REASONS_PENDING_REVIEW_EMPTY_FC: "No drafts reasons awaiting review",
    NURSE_DECLINED_REASONS_DRAFT: "Draft Reasons",
    NURSE_DECLINED_REASONS_DRAFT_FC: "Client Draft Reasons",
    NURSE_DECLINED_REASONS_DRAFT_EMPTY: "No draft reasons to view",
    NURSE_DECLINED_REASONS_DRAFT_EMPTY_FC: "No client draft reasons to view",
    NURSE_DECLINED_REASONS_TABLE_NAME: "Nurse Declined Reason",
    NURSE_DECLINED_REASONS_TABLE_ID: "ID",
    NURSE_DECLINED_REASONS_TABLE_DATE_ADDED: "Date Added",
    NURSE_DECLINED_REASONS_TABLE_DATE_DISABLED: "Date Disabled",
    NURSE_DECLINED_REASONS_TABLE_STATUS: "Status",

    NURSE_DECLINED_REASON_DETAILS: "Reason #{reasonId}",
    NURSE_DECLINED_REASON_DETAILS_DRAFT: "Draft for Reason #{reasonId}",
    NURSE_DECLINED_REASON_DETAILS_LAST_UPDATED_BY: "Last edited by:",
    NURSE_DECLINED_REASON_START_DRAFT: "Start Draft",
    NURSE_DECLINED_REASON_EDIT_CURRENT_DRAFT: "Edit Current Draft",
    NURSE_DECLINED_REASON_SUBMIT_CHANGES: "Submit Changes",
    NURSE_DECLINED_REASON_CANCEL_REVIEW: "Cancel Review",
    NURSE_DECLINED_REASON_DETAILS_MAIN_DETAILS: "Main Details",
    NURSE_DECLINED_REASON_DETAILS_REASON_ID: "Reason Id",
    NURSE_DECLINED_REASON_DETAILS_REASON: "Reason",
    NURSE_DECLINED_REASON_DETAILS_STATUS: "Status",

    NURSE_DECLINED_REASON_ADD_TITLE: "New Reason Draft",
    NURSE_DECLINED_REASON_EDIT_TITLE: "Draft for Reason #{reasonId}",
    NURSE_DECLINED_REASON_SAVE_DRAFT: "Save Draft",
    NURSE_DECLINED_REASONS_ACTION_START_SETUP_DRAFT: "Start Reason Draft",
    NURSE_DECLINED_REASONS_ACTION_VIEW_CURRENT_SETUP_DRAFT: "View Current Reason Draft",
    NURSE_DECLINED_REASONS_ACTION_EDIT_DETAILS: "Edit Details",
    NURSE_DECLINED_REASONS_ACTION_DUPLICATE_SETUP: "Duplicate Set-Up",
    NURSE_DECLINED_REASONS_ACTION_DISABLE_SETUP: "Disable Reason",
    NURSE_DECLINED_REASONS_ACTION_CANCEL_REVIEW_AND_RESUME_EDIT: "Cancel Review and Resume Editing",
    NURSE_DECLINED_REASONS_ACTION_CANCEL_REVIEW_AND_DISCARD_DRAFT:
      "Cancel Review and Discard Draft",
    NURSE_DECLINED_REASONS_ACTION_DISCARD_DRAFT: "Discard Draft",

    // EAP SIGNPOSTING
    SIGNPOSTING: "Signposting",
    EAP_LOCKED_DEPENDENCIES: "This section is locked and cannot be edited due to a dependency.",
    EAP_SIGNPOSTING_DISABLED: "EAP Signposting is off.",
    SUPPORT_SERVICES: "Support Services",

    EAP_ADD_SETUP: "Add Set-Up",
    EAP_ADD_DRAFT_SETUP: "Start Set-Up Draft",
    EAP_ADD_SETUP_FC: "Add Set-Up",
    EAP_LIVE_SETUPS: "Live Set-Ups",
    EAP_LIVE_SETUPS_FC: "Live Set-Ups",
    EAP_LIVE_SETUPS_EMPTY: "No live set-ups to review",
    EAP_LIVE_SETUPS_EMPTY_FC: "No live set-ups to review",
    EAP_SETUPS_PENDING_REVIEW: "Set-Ups Pending Review",
    EAP_SETUPS_PENDING_REVIEW_FC: "Set-Ups Drafts Awaiting Review",
    EAP_SETUPS_PENDING_REVIEW_EMPTY: "No draft set-ups pending review",
    EAP_SETUPS_PENDING_REVIEW_EMPTY_FC: "No drafts set-ups awaiting review",
    EAP_DRAFT_SETUPS: "Set-Up Drafts",
    EAP_DRAFT_SETUPS_FC: "Client Set-Up Drafts",
    EAP_DRAFT_SETUPS_EMPTY: "No draft set-ups to view",
    EAP_DRAFT_SETUPS_EMPTY_FC: "No client draft set-ups to view",

    EAP_ACTION_START_SETUP_DRAFT: "Start Set-Up Draft",
    EAP_ACTION_VIEW_CURRENT_SETUP_DRAFT: "View Current Set-Up Draft",
    EAP_ACTION_EDIT_MAIN_DETAILS: "Edit Main Details",
    EAP_ACTION_EDIT_REASON_SPECIFIC_USAGE: "Edit Reason Specific Usage",
    EAP_ACTION_EDIT_HIERARCHY_SCOPE: "Edit Hierarchy Scope",
    EAP_ACTION_DUPLICATE_SETUP: "Duplicate Set-Up",
    EAP_ACTION_DISABLE_SETUP: "Disable Set-Up",
    EAP_ACTION_CANCEL_REVIEW_AND_RESUME_EDIT: "Cancel Review and Resume Editing",
    EAP_ACTION_CANCEL_REVIEW_AND_DISCARD_DRAFT: "Cancel Review and Discard Draft",
    EAP_ACTION_DISCARD_DRAFT: "Discard Draft",

    EAP_DETAILS: "EAP Set-Up #{providerId}",
    EAP_DETAILS_DRAFT: "Draft for EAP Set-Up #{providerId}",
    EAP_DETAILS_LAST_UPDATED_BY: "Last edited by:",
    EAP_DETAILS_LOCKED_PENDING_REVIEW:
      "This draft is locked and cannot be edited as it is pending review.",
    EAP_DETAILS_LIVE_DATA_BANNER: "Following Below Is Live Data Associated with This Set-Up!",
    EAP_DETAILS_LIVE_DATA_BANNER_ADDITIONAL:
      "Note: Editing this data is outside the draft-review process and updates will take effect immediately.",
    EAP_DETAILS_MAIN_DETAILS: "Main Details",
    EAP_DETAILS_REASON_SPECIFIC_USAGE: "Reason Specific Usage",
    EAP_DETAILS_HIERARCHY_SCOPE: "Hierarchy Scope",
    EAP_DETAILS_SECTION_EMPTY: "This section has not been completed yet.",
    EAP_DETAILS_PROVIDER_NUMBER: "EAP Number",
    DETAILS_PROVIDER_NUMBER: "Number",
    EAP_DETAILS_PROVIDER_STATUS: "Status",
    EAP_DETAILS_PROVIDER_NAME: "Provider Name",
    EAP_DETAILS_PROVIDER_PHONE_NUMBER: "Phone  Number",
    EAP_DETAILS_PROVIDER_USAGE_INSTRUCTIONS: "Usage Instructions",

    EAP_START_DRAFT: "Start Draft",
    EAP_EDIT_CURRENT_DRAFT: "Edit Current Draft",
    EAP_SUBMIT_CHANGES: "Submit Changes",
    EAP_CANCEL_REVIEW: "Cancel Review",

    ADD_MODAL_TITLE: "New Set-up Draft",
    ADD_MODAL_TITLE_FC: "New Set-up",
    ADD_EAP_MODAL_STEP_1_TITLE: "1/3 Provider Details",
    ADD_EAP_MODAL_STEP_1_NEXT_BUTTON: "Next Reason Specific Usage",
    ADD_EAP_MODAL_STEP_2_TITLE: "2/3 Reason Specific Usage",
    ADD_EAP_MODAL_STEP_2_NEXT_BUTTON: "Next Hierarchy Scope",
    ADD_EAP_MODAL_STEP_3_TITLE: "3/3 Hierarchy Scope",
    ADD_EAP_MODAL_SAVE_DRAFT: "Save Draft",
    EDIT_EAP_MODAL_TITLE: "Draft for Set-up #{providerId}",
    EDIT_EAP_MODAL_TITLE_FC: "Set-up #{providerId}",
    EDIT_EAP_MODAL_STEP_1_TITLE: "1/3 Provider Details",
    EDIT_EAP_MODAL_STEP_1_NEXT_BUTTON: "Next Reason Specific Usage",
    EDIT_EAP_MODAL_STEP_2_TITLE: "2/3 Reason Specific Usage",
    EDIT_EAP_MODAL_STEP_2_NEXT_BUTTON: "Next Hierarchy Scope",
    PROVIDER_NAME: "Provider Name",
    EAP_NUMBER: "EAP Number",

    EAP_DETAILS_ABSENCE_REASON: "Absence Reason",
    EAP_DETAILS_CALL_FLOW_DISPLAY: "Call Flow Display",
    EAP_DETAILS_EMPLOYEE_TEXT: "Employee Text",
    EAP_DETAILS_SELECTED_AREAS: "Selected Areas",
    EAP_DETAILS_AREAS_RESTORED: "Areas Restored",
    EAP_DETAILS_SAVE_DRAFT: "Save Draft",
    EAP_DETAILS_SAVE: "Save",
    EAP_DETAILS_SUBMIT_FOR_REVIEW: "Submit for Review",

    // Approvable Title
    APPROVABLE_TITLE: "{type} #{id}",
    APPROVABLE_TITLE_DRAFT: "Draft for {type} #{id}",
    APPROVABLE_TITLE_LAST_UPDATED_BY: "Last edited by:",
    APPROVABLE_TITLE_SUBMITTED_BY: "Submitted by:",
    APPROVABLE_TITLE_EDIT: "Edit",
    APPROVABLE_TITLE_START_DRAFT: "Start Draft",
    APPROVABLE_TITLE_DUPLICATE: "Duplicate",
    APPROVABLE_TITLE_DISABLE: "Disable",
    APPROVABLE_TITLE_ENABLE: "Enable",
    APPROVABLE_TITLE_VIEW_CURRENT_DRAFT: "View Current Draft",
    APPROVABLE_TITLE_SUBMIT_CHANGES: "Submit Changes",
    APPROVABLE_TITLE_DISCARD_DRAFT: "Discard Draft",
    APPROVABLE_TITLE_CANCEL_SUBMISSION: "Cancel Submission",

    APPROVABLE_LOCKED_DEPENDENCIES:
      "This section is locked and cannot be edited due to a dependency.",
    APPROVABLE_DRAFT_IS_AWAITING_REVIEW: "This draft is awaiting review",
    APPROVABLE_LOCKED_PENDING_REVIEW:
      "This draft is locked and cannot be edited as it is pending review.",

    // Approvable Changeset Modals
    APPROVABLE_SUBMIT_REVIEW_TITLE: "Submission Notes",
    APPROVABLE_SUBMIT_DESCRIPTION: "Notes for submission",
    APPROVABLE_CANCEL_REVIEW_TITLE: "Cancel Review",
    APPROVABLE_CANCEL_REVIEW_QUESTION:
      'The set-up you have selected to edit "{approvableName}" is currently pending review.  Are you sure you would like to cancel the review and resume editing?',
    APPROVABLE_CANCEL_REVIEW_NO: "No, Leave in Review",
    APPROVABLE_CANCEL_REVIEW_YES: "Yes, Cancel Review and Resume Editing",
    APPROVABLE_CANCEL_REVIEW_AND_DISCARD_QUESTION:
      'The set-up you have selected to edit "{approvableName}" is currently pending review.  Are you sure you would like to cancel the review and discard the draft?',
    APPROVABLE_CANCEL_REVIEW_AND_DISCARD_YES: "Yes, Cancel Review and Discard Draft",
    APPROVABLE_DISCARD_DRAFT_TITLE: "Discard Draft",
    APPROVABLE_DISCARD_DRAFT_QUESTION:
      "Are you sure you want to discard draft for {approvableType} {approvableName}?",
    APPROVABLE_DISCARD_DRAFT_YES: "Yes, Discard Draft",
    APPROVABLE_DISABLE_SETUP_TITLE: "Disable {approvableType}",
    APPROVABLE_DISABLE_SETUP_QUESTION:
      "Are you sure you want to disable {approvableType} {approvableName}?",
    APPROVABLE_DISABLE_SETUP_INFO_ACTIVE_ONLY:
      "Please note this will create a draft for this set-up with its status changed to disabled and automatically submitted for review.",
    APPROVABLE_DISABLE_SETUP_SUBMIT_ACTIVE_ONLY: "Disable",
    APPROVABLE_DISABLE_SETUP_INFO_ACTIVE_WITH_DRAFT:
      "Please note that this record has a draft in progress.  Proceeding will change the status of the set-up in the draft, but will not submit it for review",
    APPROVABLE_DISABLE_SETUP_SUBMIT_ACTIVE_WITH_DRAFT: "Disable and Update Draft",
    APPROVABLE_DISABLE_SETUP_INFO_ACTIVE_WITH_DRAFT_PENDING_REVIEW:
      "Please note that this set-up already has a pending review.  Proceeding will update the status of the set-up in the draft and keep it in review.",
    APPROVABLE_DISABLE_SETUP_SUBMIT_ACTIVE_WITH_DRAFT_PENDING_REVIEW: "Disable and Keep in sReview",
    APPROVABLE_DISABLE_SETUP_WARNING:
      "This set-up cannot be disabled as it has an open or awaiting review draft.",
    APPROVABLE_ENABLE_SETUP_TITLE: "Enable {approvableType}",
    APPROVABLE_ENABLE_SETUP_QUESTION:
      "Are you sure you want to enable {approvableType} {approvableName}?",
    APPROVABLE_ENABLE_SETUP_INFO_ACTIVE_ONLY:
      "Please note this will create a draft for this set-up with its status changed to enabled and automatically submitted for review.",
    APPROVABLE_ENABLE_SETUP_SUBMIT_ACTIVE_ONLY: "Enable and Submit for Review",
    APPROVABLE_ENABLE_SETUP_INFO_ACTIVE_WITH_DRAFT:
      "Please note that this record has a draft in progress.  Proceeding will change the status of the set-up in the draft, but will not submit it for review",
    APPROVABLE_ENABLE_SETUP_SUBMIT_ACTIVE_WITH_DRAFT: "Enable and Update Draft",
    APPROVABLE_ENABLE_SETUP_INFO_ACTIVE_WITH_DRAFT_PENDING_REVIEW:
      "Please note that this set-up already has a pending review.  Proceeding will update the status of the set-up in the draft and keep it in review.",
    APPROVABLE_ENABLE_SETUP_SUBMIT_ACTIVE_WITH_DRAFT_PENDING_REVIEW: "Enable and Keep in Review",
    APPROVABLE_ENABLE_SETUP_WARNING:
      "This set-up cannot be enabled as it has an open or awaiting review draft.",

    // Hierarchy Scope
    HIERARCHY_SCOPE_FIND_DEPARTMENTS: "Find department...",
    HIERARCHY_SCOPE_AREAS_INCLUDED: "Areas Included",
    HIERARCHY_SCOPE_AREAS_EXCLUDED: "Areas Excluded",
    HIERARCHY_SCOPE_UNIT_NAME: "Unit Name",
    HIERARCHY_SCOPE_START_DATE: "Start Date",
    HIERARCHY_SCOPE_START_DATE_TOOLTIP:
      "Use this field to insert a date using a DD/MM/YYYY format. This date dictates the point in time at which your standard question will apply to your chosen hierarchy area(s).",
    HIERARCHY_SCOPE_END_DATE: "End Date",
    HIERARCHY_SCOPE_END_DATE_TOOLTIP:
      "If it is known, use this field to determine the point in time at which your chosen question ceases to be practically applied.",
    HIERARCHY_SCOPE_EXCLUDED_DATE: "Date Excluded",
    HIERARCHY_SCOPE_RESTORED_DATE: "Restore Date",

    // Absence Reasons
    ABSENCE_REASONS_LIVE: "Live Absence Reasons",
    ABSENCE_REASONS_LIVE_FC: "Live Absence Reasons FC",
    ABSENCE_REASONS_LIVE_EMPTY: "No Live Absence Reasons to review",
    ABSENCE_REASONS_LIVE_EMPTY_FC: "No Live Absence Reasons to review",
    ABSENCE_REASONS_PENDING_REVIEW: "Absence Reasons Pending Review",
    ABSENCE_REASONS_PENDING_REVIEW_FC: "Absence Reasons Pending Review FC",
    ABSENCE_REASONS_PENDING_REVIEW_EMPTY: "No Pending Absence Reasons to review",
    ABSENCE_REASONS_PENDING_REVIEW_EMPTY_FC: "No Pending Absence Reasons to review",
    ABSENCE_REASONS_DRAFT_FC: "Absence Reasons Drafts FC",
    ABSENCE_REASONS_DRAFT: "Absence Reasons Drafts",
    ABSENCE_REASONS_DRAFT_EMPTY: "No Draft Absence Reasons to review",
    ABSENCE_REASONS_DRAFT_EMPTY_FC: "No Draft Absence Reasons to review",
    START_ABSENCE_REASON_DRAFT: "Start Absence Reason Draft",
    ADD_ABSENCE_REASON: "Add Absence Reason",
    ABSENCE_REASON_ACTION_START_DRAFT: "Start Absence Reason Draft",
    ABSENCE_REASON_ACTION_VIEW_CURRENT_DRAFT: "View Current Absence Reason Draft",
    ABSENCE_REASON_ACTION_EDIT_MAIN_DETAILS: "Edit Main Details",
    ABSENCE_REASON_ACTION_DUPLICATE_SETUP: "Duplicate Absence Reason",
    ABSENCE_REASON_ACTION_DISABLE_SETUP: "Disable Absence Reason",
    ABSENCE_REASON_ACTION_CANCEL_REVIEW_AND_RESUME_EDIT: "Cancel Review and Resume Editing",
    ABSENCE_REASON_ACTION_CANCEL_REVIEW_AND_DISCARD_DRAFT: "Cancel Review and Discard Draft",
    ABSENCE_REASON_ACTION_EDIT_REASON_SPECIFIC_USAGE: "Edit Reason Specific Usage",
    ABSENCE_REASON_ACTION_DISCARD_DRAFT: "Discard Draft",
    ABSENCE_REASON_ACTION_EDIT_LENGTH_SCOPE: "Edit Length Scope",
    ABSENCE_REASON_ACTION_EDIT_ANSWER_OPTIONS: "Edit Answer Options",
    ABSENCE_REASON_ACTION_EDIT_QUESTION_TYPE: "Edit Question Type",
    ABSENCE_REASON_DETAILS: "Absence Reason #{id}",
    ABSENCE_REASON_DRAFT: "Draft for Absence Reason #{id}",
    ABSENCE_REASON_LAST_UPDATED_BY: "Last edited by:",
    ABSENCE_REASON_DETAILS_QUESTION_TYPE: "Question Type",
    ABSENCE_REASON_DETAILS_REASON_SCOPE: "Reason Scope",
    ABSENCE_REASON_DETAILS_SECTION_EMPTY: "This section has not been completed yet.",
    ABSENCE_REASON_DETAILS_LENGTH_SCOPE: "Length Scope",
    ABSENCE_REASON_DETAILS_ANSWER_OPTIONS: "Answer Options",
    EDIT_ABSENCE_REASON_MODAL_TITLE: "Draft for Absence Reason #{providerId}",
    EDIT_ABSENCE_REASON_MODAL_TITLE_FC: "Absence Reason #{providerId}",
    APPROVABLE_TYPE_ABSENCE: "Absence Reason",
    ABSENCE_REASONS_ID: "Id",
    ABSENCE_REASONS_ABSENCE_REASON: "Absence Reason",
    ABSENCE_REASONS_PARENT_REASON: "Parent Reason",
    ABSENCE_REASONS_NURSE_ELIGIBILITY: "Nurse Eligibility",
    ABSENCE_REASONS_NURSE_TRANSFER_ELIGIBILITY_ABSENCE_DURATION: "Nurse Min Duration",
    ABSENCE_REASONS_DISPLAY_NAME: "Display Name",
    ABSENCE_REASONS_TYPE: "Type",
    ABSENCE_REASONS_DATE_ADDED: "Date Added",
    APPROVABLE_TYPE_ABSENCE_REASON: "Absence Reason",
    ADD_ABSENCE_REASON_MODAL_TITLE: "New Absence Reason",
    ADD_ABSENCE_REASON_SUBMIT_BUTTON: "Add New Reason",
    EDIT_ABSENCE_REASON_SUBMIT_BUTTON: "Save Absence Reason",
    ABSENCE_REASON_NAME: "Name",
    ABSENCE_REASON_DETAILS_MAIN_DETAILS: "Main Details",
    ABSENCE_REASON_DETAILS_LOCKED_PENDING_REVIEW: "Absence Reason Pending Review",
    MEDICAL: "Medical",
    NON_MEDICAL: "Non-Medical",

    // ALERTS
    ALERTS: "Alerts",
    ALERTS_LOCKED_DEPENDENCIES: "This section is locked and cannot be edited due to a dependency.",
    ALERTS_CREATE_NEW: "Create New Alert Draft",
    ALERTS_CREATE_NEW_FC: "Create New Alert",
    ALERTS_VIEW_RECENTLY_TRIGGERED_ALERTS: "View Recently Triggered Alerts",
    ALERTS_LIVE_REASONS: "Live Alerts",
    ALERTS_LIVE_REASONS_FC: "Live Alerts",
    ALERTS_LIVE_REASONS_EMPTY: "No live alerts to review",
    ALERTS_LIVE_REASONS_EMPTY_FC: "No live alerts to review",
    ALERTS_PENDING_REVIEW: "Alerts Pending Review",
    ALERTS_PENDING_REVIEW_FC: "Alerts Pending Review",
    ALERTS_PENDING_REVIEW_EMPTY: "No draft alerts pending review",
    ALERTS_PENDING_REVIEW_EMPTY_FC: "No drafts alerts awaiting review",
    ALERTS_DRAFT: "Draft Alerts",
    ALERTS_DRAFT_FC: "Client Draft Alerts",
    ALERTS_DRAFT_EMPTY: "No draft alerts to view",
    ALERTS_DRAFT_EMPTY_FC: "No client draft alerts to view",
    ALERTS_ALERT_ID: "Alert ID",
    ALERTS_ALERT_TYPE: "Alert Type",
    ALERTS_ALERT_NAME: "Alert Name",
    ALERTS_ALERT_ABSENCE_TYPE: "Absence Type",
    ALERTS_ALERT_ABSENCE_TYPES_COVERED: "Absence Types Covered",
    ALERTS_ALERT_VALID_FROM: "Valid From",
    ALERTS_ALERT_END_DATE: "End Date",
    ALERTS_ALERT_STATUS: "Status",
    ALERTS_ALERT_TRIGGER_POINT: "Trigger Point",
    ALERTS_ALERT_PURPOSE: "Alert Purpose",
    ALERTS_ALERT_FTE_PRO_RATA_ADJUSTMENT: "FTE Pro-Rata Adjustment",

    ALERT_DETAILS_ID: "Alert #{alertId}",
    ALERT_DETAILS_DRAFT: "Draft for Alert #{alertId}",
    ALERT_DETAILS_LAST_UPDATED_BY: "Last edited by:",
    ALERT_DETAILS_LOCKED_PENDING_REVIEW:
      "This draft is locked and cannot be edited as it is pending review.",
    ALERT_START_DRAFT: "Start Draft",
    ALERT_EDIT_CURRENT_DRAFT: "Edit Current Draft",
    ALERT_SUBMIT_CHANGES: "Submit Changes",
    ALERT_CANCEL_REVIEW: "Cancel Review",
    ALERT_DETAILS_SECTION_EMPTY: "This section has not been completed yet.",
    ALERT_DETAILS_CRITERIA: "Criteria",
    ALERT_DETAILS_CRITERIA_ALERT_DETAILS: "Alert Details",
    ALERT_DETAILS_CRITERIA_REASONS_FOR_EXCLUSIONS: "Reasons for Excluding an Employee",
    ALERT_DETAILS_EMPLOYEE_EXCLUSION_REASON: "Reason",
    ALERT_DETAILS_EMPLOYEE_EXCLUSION_STATUS: "Status",
    ALERT_DETAILS_ADD_EXCLUSION_REASON: "Add Reason for Exclusion",
    ALERT_DETAILS_CONTENT: "Content",
    ALERT_DETAILS_CONTENT_INSTRUCTION_TEXT: "Instruction Text",
    ALERT_DETAILS_CONTENT_ENTER_NOTES: "Enter your notes here",
    ALERT_DETAILS_CONTENT_INFO: "Info to Be Included in Alert Email Content",
    ALERT_DETAILS_CONTENT_EMAIL_ATTACHMENTS: "Email Attachments",
    ALERT_DETAILS_CONTENT_UPLOAD_EMAIL:
      "Upload email attachments for this alert from the alert details page.",
    ALERT_DETAILS_RECIPIENTS: "Recipients",
    ALERT_DETAILS_DEFAULT_RECIPIENTS: "Default Contact Recipients",
    ALERT_DETAILS_BESPOKE_RECIPIENTS: "Bespoke Recipients",
    ALERT_DETAILS_BESPOKE_RECIPIENTS_SETUP:
      "Setup bespoke recipients for this alert on the alert details page.",
    ALERT_DETAILS_ADD_BESPOKE_RECIPIENT: "Add Bespoke Recipient",
    ALERT_DETAILS_BESPOKE_RECIPIENTS_EMPLOYEE_REF: "Employee Ref",
    ALERT_DETAILS_BESPOKE_RECIPIENTS_EMPLOYEE_NAME: "Employee Name",
    ALERT_DETAILS_BESPOKE_RECIPIENTS_DEPARTMENT: "Department",
    ALERT_DETAILS_EMAIL_ATTACHMENTS: "Email Attachments",
    ALERT_DETAILS_ADD_EMAIL_ATTACHMENT: "Add Attachment",
    ALERT_DETAILS_EMAIL_ATTACHMENT_ID: "Attachment Id",
    ALERT_DETAILS_EMAIL_ATTACHMENT_NAME: "File Name",
    ALERT_DETAILS_BESPOKE_WORK_EMAIL_ADDRESS: "Work Email Address",

    ALERT_DETAILS_ABSENCE_REASONS: "Absence Reasons",
    ALERT_DETAILS_REASON_SCOPE: "Reason Scope",
    ALERT_DETAILS_REASON_SCOPE_ALL: "All",
    ALERT_DETAILS_REASON_SCOPE_SPECIFIC_REASON: "Specific Reason",
    ALERT_DETAILS_ADD_ABSENCE_REASON: "Add Absence Reason",

    ALERT_DETAILS_RESTRICT_TO_STAFF_GROUPS: "Restrict to Staff Groups",
    ALERT_DETAILS_STAFF_GROUPS: "Staff Groups",
    ALERT_DETAILS_ADD_STAFF_GROUP: "Add Staff Group",

    ALERT_DETAILS_SERVICE_LENGTH: "Service Length",
    ALERT_DETAILS_SERVICE_LENGTH_RESTRICT: "Restrict to Employees Who Have Worked",
    ALERT_DETAILS_SERVICE_LENGTH_RESTRICT_LESS_THAN:
      "Restrict to Employees Who Have Worked Less Than",
    ALERT_DETAILS_SERVICE_LENGTH_RESTRICT_MORE_THAN:
      "Restrict to Employees Who Have Worked More Than",
    ALERT_DETAILS_SERVICE_LENGTH_UNRESTRICTED: "Not Restricted",

    ALERT_DETAILS_HIERARCHY_SCOPE: "Hierarchy Scope",
    ALERT_DETAILS_LIVE_DATA_BANNER: "Following Below Is Live Data Associated with This Set-Up!",
    ALERT_DETAILS_LIVE_DATA_BANNER_ADDITIONAL:
      "Note: Editing this data is outside the draft-review process and updates will take effect immediately.",

    ALERT_ADD_TITLE: "New Alert Draft",
    ALERT_EDIT_TITLE: "Draft for Alert #{alertId}",
    ALERT_EDIT_HIERARCHY_SCOPE: "Alert #{alertId} Hierarchy Scope",
    ALERT_SAVE_DRAFT: "Save Draft",
    ALERT_STEP0: "Alert Type",
    ALERT_STEP0_NEXT_BUTTON: "Next: Criteria",
    ALERT_STEP1: "Criteria",
    ALERT_STEP1_NEXT_BUTTON: "Next: Content",
    ALERT_STEP2: "Content",
    ALERT_STEP2_NEXT_BUTTON: "Next: Absence Reasons",
    ALERT_STEP3: "Absence Reasons",
    ALERT_STEP3_NEXT_BUTTON: "Next: Recipients",
    ALERT_STEP4: "Recipients",
    ALERT_STEP4_NEXT_BUTTON: "Next: Restrict to Staff Groups",
    ALERT_STEP5: "Restrict to Staff Groups",
    ALERT_STEP5_NEXT_BUTTON: "Next: Service Length",
    ALERT_STEP6: "Service Length",
    ALERT_STEP6_NEXT_BUTTON: "Next: Hierarchy Scope",
    ALERT_STEP7: "Hierarchy Scope",

    ALERTS_ACTION_START_SETUP_DRAFT: "Start Set-Up Draft",
    ALERTS_ACTION_VIEW_CURRENT_SETUP_DRAFT: "View Current Set-Up Draft",
    ALERTS_ACTION_EDIT_DETAILS: "Edit Details",
    ALERTS_ACTION_EDIT_HIERARCHY_SCOPE: "Edit Hierarchy Scope",
    ALERTS_ACTION_DUPLICATE_SETUP: "Duplicate Set-Up",
    ALERTS_ACTION_DISABLE_SETUP: "Disable Set-Up",
    ALERTS_ACTION_CANCEL_REVIEW_AND_RESUME_EDIT: "Cancel Review and Resume Editing",
    ALERTS_ACTION_CANCEL_REVIEW_AND_DISCARD_DRAFT: "Cancel Review and Discard Draft",
    ALERTS_ACTION_DISCARD_DRAFT: "Discard Draft",
    APPROVABLE_TYPE_ALERT: "Alert",

    // Alert Types Enum Values
    ABSENCE_RATE_PERCENTAGE: "Absence rate percentage",
    ABSENCE_REASON_ALERT_TYPE: "Absence reason alert type",
    BRADFORD_SCORE_OVER_X_IN_Y_MONTHS: "Bradford score over x in y months",
    HOURS_LOST_OVER_AVG_WCH_IN_Y_PERIOD_OVER_Z_PERIOD_TYPE:
      "Hours lost over avg wch in y period over z period type",
    WORK_RELATED: "Work related",
    X_DAY_TYPE_IN_Y_PERIOD_TYPE: "X day type in y period type",
    X_DAY_TYPE_OF_CONTINUOUS_ABSENCE: "X day type of continuous absence",
    X_DAY_TYPE_OR_Z_SPELLS_IN_Y_PERIOD_TYPE: "X day type or z spells in y period type",
    X_DAY_TYPE_OVER_Z_SPELLS_IN_Y_PERIOD_TYPE: "X day type over z spells in y period type",
    X_HOURS_IN_Y_PERIOD_TYPE: "X hours in y period type",
    X_SPELLS_IN_Y_PERIOD_TYPE: "X spells in y period type",
    X_SPELLS_OF_LESS_GREATER_THAN_Z_DAY_TYPE_IN_Y_PERIOD_TYPE:
      "X spells of less greater than z day type in y period type",
    X_SPELLS_OF_SAME_REASON_IN_Y_PERIOD_TYPE: "X spells of same reason in y period type",

    // Alert Trigger Mode Enum Values
    ACTUAL_TIME: "Actual Time",
    ON_CLOSE: "On Close",
    PREDICTED: "Predicted",

    // Alert Purpose Enum Values
    MONITORING_PROMPT: "Monitoring Prompt",
    NURSE_CALLBACK: "Nurse Callback",
    REFERENCE_ALERT: "Reference Alert",
    WELLBEING_REFERRAL: "Wellbeing Referral",

    // Alert MoreOrLessThan Enum Values
    LESS_THAN: "Less Than",
    MORE_THAN: "More Than",

    // Referrals
    REFERRAL_APPROVABLE_TYPE: "Referral",
    REFERRALS: "Referrals",
    REFERRALS_ADMIN: "Referral Interview Admin",
    REFERRALS_PAGE_DESCRIPTION:
      "What is physically asked of an employee during a return to work interview is configured (and subsequently controlled) using this page.",
    REFERRAL_LOCKED_DEPENDENCIES:
      "This section is locked and cannot be edited due to a dependency.",
    CREATE_NEW_PROCESS_DRAFT: "Create New Process Draft",
    REFERRAL_CREATE_NEW_FC: "Create New Process",
    REFERRAL_LIVE_REASONS: "Live Processes",
    REFERRAL_LIVE_REASONS_FC: "Live Processes",
    REFERRAL_LIVE_REASONS_EMPTY: "No live processes to review",
    REFERRAL_LIVE_REASONS_EMPTY_FC: "No live processes to review",
    REFERRAL_PENDING_REVIEW: "Processes Pending Review",
    REFERRAL_PENDING_REVIEW_FC: "Processes Pending Review",
    REFERRAL_PENDING_REVIEW_EMPTY: "No draft processes pending review",
    REFERRAL_PENDING_REVIEW_EMPTY_FC: "No drafts processes awaiting review",
    REFERRAL_DRAFT: "Draft Processes",
    CLIENT_DRAFT_PROCESSES: "Client Draft Processes",
    REFERRAL_DRAFT_EMPTY: "No draft processes to view",
    REFERRAL_DRAFT_EMPTY_FC: "No client draft processes to view",
    REFERRAL_PROCESS: "Referral Process",
    REFERRAL_PROCESS_ID: "Referral ID",
    REFERRAL_PROCESS_NAME: "Referral Process Name",
    REFERRAL_PROCESS_STATUS: "Status",
    REFERRAL_PROCESS_DATE_CREATED: "Date Created",
    REFERRAL_PROCESS_CREATED_BY: "Created By",

    REFERRAL_DETAILS_PROCESSID: "Referral Process #{processId}",
    REFERRAL_DETAILS_TITLE: "Referral Details",
    REFERRAL_DETAILS_DRAFT: "Draft for Referral Process #{processId}",
    REFERRAL_DETAILS_LAST_UPDATED_BY: "Last edited by:",
    REFERRAL_DETAILS_LOCKED_PENDING_REVIEW:
      "This draft is locked and cannot be edited as it is pending review.",
    REFERRAL_START_DRAFT: "Start Referral Process",
    REFERRAL_EDIT_CURRENT_DRAFT: "Edit Current Process",
    REFERRAL_SUBMIT_CHANGES: "Submit Changes",
    REFERRAL_CANCEL_REVIEW: "Cancel Review",
    REFERRAL_DETAILS_SECTION_EMPTY: "This section has not been completed yet.",
    ALERTS_FOR_MANAGER_LED_REFERRALS: "Alerts for Manager Led Referrals",
    AT_LEAST_ONE_ACTIVE_REASON_MUST_BE_PROVIDED: "At least one active reason must be provided",
    REFERRAL_DETAILS_REFERRAL_MECHANISM: "Referral Mechanism",
    ACTIVE: "Active",
    REASON: "Reason",
    COMPLIANCE_SETTINGS: "Compliance Settings",
    REFERRAL_DETAILS_ALERTS_FOR_EMPLOYEE_LED_REFERRALS: "Alerts for Employee Led Referrals",
    REFERRAL_DETAILS_DECLINING_REFERRALS: "Declining Referrals",
    DECLINED_REFERRAL: "Declined Referral",
    PLEASE_REVIEW_THE_ALERT_LIST:
      "One or more alerts are already in use for Manager Led Referrals. Please review the alert list and update it where needed.",
    TRACKING: "Tracking",
    REQUIRED_RESPONSE: "Required Response",
    OUTCOME_OPTIONS: "Outcome options",
    REFERRAL_QUESTIONS: "Referral Questions",
    REFERRAL_DETAILS_OUTCOMES: "Outcomes",
    NO_OUTCOME_ERROR: "You should specify a valid 'Outcome'",
    NO_REASON_ERROR: "You should specify a valid 'Reason'",
    REFERRAL_DETAILS_ADD_ATTACHMENT: "Add Attachment",
    REFERRAL_DETAILS_ADD_ATTACHMENTS_INFO:
      "Upload notification attachments for this Referral process from the Referral details page.",
    REFERRAL_DETAILS_HIERARCHY_SCOPE: "Hierarchy Scope",
    REFERRAL_DETAILS_LIVE_DATA_BANNER: "Following Below Is Live Data Associated with This Set-Up!",
    REFERRAL_DETAILS_LIVE_DATA_BANNER_ADDITIONAL:
      "Note: Editing this data is outside the draft-review process and updates will take effect immediately.",

    REFERRAL_ADD_TITLE: "New Referral Process",
    REFERRAL_EDIT_TITLE: "Draft for Referral Process #{processId}",
    REFERRAL_EDIT_HIERARCHY_SCOPE_TITLE: "Referral Process #{processId} Hierarchy Scope",
    REFERRAL_SAVE_DRAFT: "Save Draft",
    SUPPLIER_DETAILS: "Supplier Details",
    NEXT_MANAGER_LED_REFERRALS: "Next: Manager Led Referrals",
    MANAGER_LED_REFERRALS: "Manager Led Referrals",
    NEXT_EMPLOYEE_LED_REFERRALS: "Next: Employee Led Referrals",
    EMPLOYEE_LED_REFERRALS: "Employee Led Referrals",
    NEXT_SUPPLIER_TRACKING: "Next: Supplier Tracking",
    SUPPLIER_TRACKING: "Supplier Tracking",
    NEXT_MANUAL_REFERRALS: "Next: Manual Referrals",
    MANUAL_REFERRALS: "Manual Referrals",
    NEXT_HIERARCHY_SCOPE: "Next: Hierarchy Scope",
    REFERRAL_STEP6: "Hierarchy Scope",
    EMPLOYEE_REFERRAL_NO_ALERT_CONFIGURATION:
      "For a successful Referrals process configuration, please ensure that the alerts are set up with the correct 'Alert Purpose - Wellbeing Referral' before creating a new process.",
    ABSENCE_MONITORING_NO_ALERT_CONFIGURATION:
      "For a successful Absence Monitoring process configuration, please ensure that the alerts are set up with the correct 'Alert Purpose - Monitoring Prompt' before creating a new process.",

    REFERRAL_ACTION_START_SETUP_DRAFT: "Start Process Draft",
    REFERRAL_ACTION_VIEW_CURRENT_SETUP_DRAFT: "View Current Process Draft",
    REFERRAL_ACTION_EDIT_DETAILS: "Edit Details",
    REFERRAL_ACTION_EDIT_HIERARCHY_SCOPE: "Edit Hierarchy Scope",
    REFERRAL_ACTION_DUPLICATE_SETUP: "Duplicate Process",
    REFERRAL_ACTION_DISABLE_SETUP: "Disable Process",
    REFERRAL_ACTION_CANCEL_REVIEW_AND_RESUME_EDIT: "Cancel Review and Resume Editing",
    REFERRAL_ACTION_CANCEL_REVIEW_AND_DISCARD_DRAFT: "Cancel Review and Discard Draft",
    REFERRAL_ACTION_DISCARD_DRAFT: "Discard Draft",
    REFERRAL_DETAILS_REASONS_FOR_REFERRAL: "Reasons for Referral",
    REFERRAL_DETAILS_SUPPLIER_TRACKING_ENABLED: "Supplier Tracking Enabled",
    REFERRAL_DETAILS_SUPPLIER_TRACKING_DECLINE_ESCALATION: "Decline Escalation",

    // Return to Work (RTW)
    RETURN_TO_WORK_APPROVABLE_TYPE: "RTW",
    RETURN_TO_WORK_INTERVIEWS: "Return to Work Interviews",
    RETURN_TO_WORK_INTERVIEWS_ADMIN: "RTW Interview Admin",
    RETURN_TO_WORK_INTERVIEWS_PAGE_DESCRIPTION:
      "What is physically asked of an employee during a return to work interview is configured (and subsequently controlled) using this page.",
    RETURN_TO_WORK_LOCKED_DEPENDENCIES:
      "This section is locked and cannot be edited due to a dependency.",
    RETURN_TO_WORK_CREATE_NEW: "Create New Process Draft",
    RETURN_TO_WORK_CREATE_NEW_FC: "Create New Process",
    RETURN_TO_WORK_LIVE_REASONS: "Live Processes",
    RETURN_TO_WORK_LIVE_REASONS_FC: "Live Processes",
    RETURN_TO_WORK_LIVE_REASONS_EMPTY: "No live processes to review",
    RETURN_TO_WORK_LIVE_REASONS_EMPTY_FC: "No live processes to review",
    RETURN_TO_WORK_PENDING_REVIEW: "Processes Pending Review",
    RETURN_TO_WORK_PENDING_REVIEW_FC: "Processes Pending Review",
    RETURN_TO_WORK_PENDING_REVIEW_EMPTY: "No draft processes pending review",
    RETURN_TO_WORK_PENDING_REVIEW_EMPTY_FC: "No drafts processes awaiting review",
    RETURN_TO_WORK_DRAFT: "Draft Processes",
    RETURN_TO_WORK_DRAFT_FC: "Client Draft Processes",
    RETURN_TO_WORK_DRAFT_EMPTY: "No draft processes to view",
    RETURN_TO_WORK_DRAFT_EMPTY_FC: "No client draft processes to view",
    RETURN_TO_WORK_PROCESS: "RTW Process",
    RETURN_TO_WORK_PROCESS_ID: "RTW ID",
    RETURN_TO_WORK_PROCESS_NAME: "RTW Process Name",
    RETURN_TO_WORK_LENGTH_SCOPE: "Length Scope (Working Days)",
    RETURN_TO_WORK_PROCESS_STATUS: "Status",
    RETURN_TO_WORK_PROCESS_DATE_CREATED: "Date Created",
    RETURN_TO_WORK_PROCESS_CREATED_BY: "Created By",

    RETURN_TO_WORK_DETAILS: "RTW Process #{processId}",
    RETURN_TO_WORK_DETAILS_DRAFT: "Draft for RTW Process #{processId}",
    RETURN_TO_WORK_DETAILS_LAST_UPDATED_BY: "Last edited by:",
    RETURN_TO_WORK_DETAILS_LOCKED_PENDING_REVIEW:
      "This draft is locked and cannot be edited as it is pending review.",
    RETURN_TO_WORK_START_DRAFT: "Start RTW Process",
    RETURN_TO_WORK_EDIT_CURRENT_DRAFT: "Edit Current Process",
    RETURN_TO_WORK_SUBMIT_CHANGES: "Submit Changes",
    RETURN_TO_WORK_CANCEL_REVIEW: "Cancel Review",
    RETURN_TO_WORK_DETAILS_SECTION_EMPTY: "This section has not been completed yet.",
    RETURN_TO_WORK_DETAILS_SETTINGS: "Settings",
    RETURN_TO_WORK_DETAILS_REASON_SCOPE: "Reason Scope",
    RETURN_TO_WORK_DETAILS_ADD_REASON: "Add Reason",
    RETURN_TO_WORK_DETAILS_COMPLIANCE: "Compliance",
    RETURN_TO_WORK_DETAILS_COMPLIANCE_KPIS_ADD_NEW: "Add New",
    RETURN_TO_WORK_DETAILS_REASONS_LATE_SUBMISSION: "Reasons for Late Submission",
    RETURN_TO_WORK_DETAILS_FORM: "Form",
    RETURN_TO_WORK_DETAILS_ADD_QUESTION: "Add Question",
    RETURN_TO_WORK_DETAILS_NOTIFICATIONS: "Notifications",
    RETURN_TO_WORK_DETAILS_NOTIFICATION_ATTACHMENTS: "Notification Attachments",
    RETURN_TO_WORK_DETAILS_ADD_ATTACHMENT: "Add Attachment",
    RETURN_TO_WORK_DETAILS_ADD_ATTACHMENTS_INFO:
      "Upload notification attachments for this RTW process from the RTW details page.",
    RETURN_TO_WORK_DETAILS_HIERARCHY_SCOPE: "Hierarchy Scope",
    RETURN_TO_WORK_DETAILS_LIVE_DATA_BANNER:
      "Following Below Is Live Data Associated with This Set-Up!",
    RETURN_TO_WORK_DETAILS_LIVE_DATA_BANNER_ADDITIONAL:
      "Note: Editing this data is outside the draft-review process and updates will take effect immediately.",

    RETURN_TO_WORK_ADD_TITLE: "New RTW Process",
    RETURN_TO_WORK_EDIT_TITLE: "Draft for RTW Process #{processId}",
    RETURN_TO_WORK_EDIT_HIERARCHY_SCOPE_TITLE: "RTW Process #{processId} Hierarchy Scope",
    RETURN_TO_WORK_SAVE_DRAFT: "Save Draft",
    RETURN_TO_WORK_STEP1: "Settings",
    RETURN_TO_WORK_STEP1_NEXT_BUTTON: "Next: Compliance",
    RETURN_TO_WORK_STEP2: "Compliance",
    RETURN_TO_WORK_STEP2_NEXT_BUTTON: "Next: Form",
    RETURN_TO_WORK_STEP3: "Form",
    RETURN_TO_WORK_STEP3_NEXT_BUTTON: "Next: Notifications",
    RETURN_TO_WORK_STEP4: "Notifications",
    RETURN_TO_WORK_STEP4_NEXT_BUTTON: "Next: Hierarchy Scope",
    RETURN_TO_WORK_STEP5: "Hierarchy Scope",
    RETURN_TO_WORK_ADD_REASON: "Add Reason",

    RETURN_TO_WORK_ACTION_START_SETUP_DRAFT: "Start Process Draft",
    RETURN_TO_WORK_ACTION_VIEW_CURRENT_SETUP_DRAFT: "View Current Process Draft",
    RETURN_TO_WORK_ACTION_EDIT_DETAILS: "Edit Details",
    RETURN_TO_WORK_ACTION_EDIT_HIERARCHY_SCOPE: "Edit Hierarchy Scope",
    RETURN_TO_WORK_ACTION_DUPLICATE_SETUP: "Duplicate Process",
    RETURN_TO_WORK_ACTION_DISABLE_SETUP: "Disable Process",
    RETURN_TO_WORK_ACTION_CANCEL_REVIEW_AND_RESUME_EDIT: "Cancel Review and Resume Editing",
    RETURN_TO_WORK_ACTION_CANCEL_REVIEW_AND_DISCARD_DRAFT: "Cancel Review and Discard Draft",
    RETURN_TO_WORK_ACTION_DISCARD_DRAFT: "Discard Draft",
    RETURN_TO_WORK_PROCESS_ID_VIEW: "RTW Process ID",
    RETURN_TO_WORK_CREATION_RULE: "Creation Rule",
    RETURN_TO_WORK_ABSENCE_TYPE_SCOPE: "Absence Type Scope",
    RETURN_TO_WORK_ELIGIBILITY_RULE: "Eligibility Rule",
    RETURN_TO_WORK_MANAGER_CAN_CHANGE_REASON: "Manager Can Change Reason",
    RETURN_TO_WORK_REASON_SCOPE: "Reason Scope",
    CAN_CHANGE: "Can Change",
    CANNOT_CHANGE: "Cannot Change",
    ATTACH: "Attach",
    DO_NOT_ATTACH: "Do Not Attach",
    RETURN_TO_WORK_MANAGER_INSTRUCTIONS: "Manager Instructions",
    RETURN_TO_WORK_OVERDUE_RTW_INSTRUCTIONS: "Overdue RTW Instructions",
    RETURN_TO_WORK_ATTACH_ABSENCE_REPORT: "Attach Absence Report",
    CAPTURE_LATE_REAS: "Capture Late Reason",
    DO_NOT_CAPTURE: "Do Not Capture",
    EXPIRY_PERIOD: "Expiry Period",
    REMINDER_TIME: "Reminder Time",
    COPY_IN_MANAGERS_MANAGER: "Copy in Manager`s Manager",
    LATE_REASON_CAPTURE: "Late Reason Capture",
    REMINDER_TYPE: "Reminder Type",
    ONE_OFF: "One off",
    REPEATING: "Repeating",

    // Absence Monitoring
    ABSENCE_MONITORING_APPROVABLE_TYPE: "Absence Monitoring",
    ABSENCE_MONITORING_PROCESSES: "Absence Monitoring Processes",
    ABSENCE_MONITORING_LOCKED_DEPENDENCIES:
      "This section is locked and cannot be edited due to a dependency.",
    ABSENCE_MONITORING_CREATE_NEW: "Create New Process Draft",
    ABSENCE_MONITORING_CREATE_NEW_FC: "Create New Process",
    ABSENCE_MONITORING_LIVE_REASONS: "Live Processes",
    ABSENCE_MONITORING_LIVE_REASONS_FC: "Live Processes",
    ABSENCE_MONITORING_LIVE_REASONS_EMPTY: "No live processes to review",
    ABSENCE_MONITORING_LIVE_REASONS_EMPTY_FC: "No live processes to review",
    ABSENCE_MONITORING_PENDING_REVIEW: "Processes Pending Review",
    ABSENCE_MONITORING_PENDING_REVIEW_FC: "Processes Pending Review",
    ABSENCE_MONITORING_PENDING_REVIEW_EMPTY: "No draft processes pending review",
    ABSENCE_MONITORING_PENDING_REVIEW_EMPTY_FC: "No drafts processes awaiting review",
    ABSENCE_MONITORING_DRAFT: "Draft Processes",
    ABSENCE_MONITORING_DRAFT_FC: "Client Draft Processes",
    ABSENCE_MONITORING_DRAFT_EMPTY: "No draft processes to view",
    ABSENCE_MONITORING_DRAFT_EMPTY_FC: "No client draft processes to view",
    ABSENCE_MONITORING_PROCESS: "Absence Monitoring Process",
    ABSENCE_MONITORING_PROCESS_ID: "ID",
    ABSENCE_MONITORING_PROCESS_NAME: "Process Name",
    ABSENCE_MONITORING_PROCESS_STATUS: "Status",
    ABSENCE_MONITORING_PROCESS_DATE_CREATED: "Date Created",
    ABSENCE_MONITORING_PROCESS_CREATED_BY: "Created By",

    ABSENCE_MONITORING_PROCESS_ID_TITLE: "Process ID",
    ABSENCE_MONITORING_PROCESS_NAME_TITLE: "Absence Monitoring Name",
    ABSENCE_MONITORING_PROCESS_TYPE: "Absence Monitoring Type",
    BASIC: "Basic",

    ABSENCE_MONITORING_DETAILS_TITLE: "Absence Monitoring Process #{processId}",
    ABSENCE_MONITORING_DETAILS_DRAFT_TITLE: "Draft for Absence Monitoring Process #{processId}",
    ABSENCE_MONITORING_DETAILS_LAST_UPDATED_BY: "Last edited by:",
    ABSENCE_MONITORING_DETAILS_LOCKED_PENDING_REVIEW:
      "This draft is locked and cannot be edited as it is pending review.",
    ABSENCE_MONITORING_START_DRAFT: "Start Absence Monitoring Process",
    ABSENCE_MONITORING_EDIT_CURRENT_DRAFT: "Edit Current Process",
    ABSENCE_MONITORING_SUBMIT_CHANGES: "Submit Changes",
    ABSENCE_MONITORING_CANCEL_REVIEW: "Cancel Review",
    ABSENCE_MONITORING_DETAILS_SECTION_EMPTY: "This section has not been completed yet.",
    ABSENCE_MONITORING_DETAILS_SETTINGS: "Settings",
    ABSENCE_MONITORING_DETAILS_MONITORING_LEVELS: "Monitoring Levels",
    ACTION_LISTS: "Action Lists",
    ABSENCE_MONITORING_DETAILS_TASKS: "Tasks",
    ABSENCE_MONITORING_DETAILS_HIERARCHY_SCOPE: "Hierarchy Scope",
    ABSENCE_MONITORING_DETAILS_LIVE_DATA_BANNER:
      "Following Below Is Live Data Associated with This Set-Up!",
    ABSENCE_MONITORING_DETAILS_LIVE_DATA_BANNER_ADDITIONAL:
      "Note: Editing this data is outside the draft-review process and updates will take effect immediately.",
    ABSENCE_MONITORING_DETAILS_PROCESS_SETTINGS: "Process Settings",
    ABSENCE_MONITORING_DETAILS_COMPLIANCE_SETTINGS: "Compliance Settings",
    ABSENCE_MONITORING_DETAILS_REASONS_FOR_NO_ACTION: "Reasons for Taking No Action",
    ABSENCE_MONITORING_DETAILS_REASONS_FOR_DEFERRING_ACTION: "Reasons for Deferring Action",
    ABSENCE_MONITORING_DETAILS_REASONS_ADDITIONAL_SUPPORT_ACTIONS: "Additional Support Actions",
    ABSENCE_MONITORING_DETAILS_ADD_REASON_FOR_TAKING_NO_ACTION: "Add Reason for Taking No Action",
    ABSENCE_MONITORING_DETAILS_ADD_REASON_FOR_DEFERRING_ACTION: "Add Reason for Deferring Action",
    ABSENCE_MONITORING_DETAILS_ADD_ADDITIONAL_SUPPORT_ACTION: "Add Additional Support Action",

    ABSENCE_MONITORING_ADD_TITLE: "New Absence Monitoring Process",
    ABSENCE_MONITORING_EDIT_TITLE: "Draft for Absence Monitoring Process #{processId}",
    ABSENCE_MONITORING_EDIT_HIERARCHY_SCOPE_TITLE:
      "Absence Monitoring Process #{processId} Hierarchy Scope",
    ABSENCE_MONITORING_SAVE_DRAFT: "Save Draft",
    ABSENCE_MONITORING_STEP1: "Settings",
    ABSENCE_MONITORING_STEP1_NEXT_BUTTON: "Next: Tasks",
    ABSENCE_MONITORING_STEP2: "Tasks",
    ABSENCE_MONITORING_STEP2_NEXT_BUTTON: "Next: Monitoring Levels",
    ABSENCE_MONITORING_STEP3: "Monitoring Levels",
    ABSENCE_MONITORING_STEP_MONITORING_NEXT_BUTTON: "Next: Action Lists",
    ABSENCE_MONITORING_STEP4_NEXT_BUTTON: "Next: Hierarchy Scope",
    ABSENCE_MONITORING_STEP5: "Hierarchy Scope",
    ABSENCE_MONITORING_ADD_REASON: "Add Reason",

    ABSENCE_MONITORING_ACTION_START_SETUP_DRAFT: "Start Process Draft",
    ABSENCE_MONITORING_ACTION_VIEW_CURRENT_SETUP_DRAFT: "View Current Process Draft",
    ABSENCE_MONITORING_ACTION_EDIT_DETAILS: "Edit Details",
    ABSENCE_MONITORING_ACTION_EDIT_HIERARCHY_SCOPE: "Edit Hierarchy Scope",
    ABSENCE_MONITORING_ACTION_DUPLICATE_SETUP: "Duplicate Process",
    ABSENCE_MONITORING_ACTION_DISABLE_SETUP: "Disable Process",
    ABSENCE_MONITORING_ACTION_CANCEL_REVIEW_AND_RESUME_EDIT: "Cancel Review and Resume Editing",
    ABSENCE_MONITORING_ACTION_CANCEL_REVIEW_AND_DISCARD_DRAFT: "Cancel Review and Discard Draft",
    ABSENCE_MONITORING_ACTION_DISCARD_DRAFT: "Discard Draft",

    ABSENCE_MONITORING_LEVEL_NO: "Level {no}",
    ABSENCE_MONITORING_LEVEL_EMPLOYESS_NO: "{no} employees",
    ABSENCE_MONITORING_LEVEL_NAME: "Level Name",
    ABSENCE_MONITORING_LEVEL_DESCRIPTION: "Level Description",
    ABSENCE_MONITORING_LEVEL_ALERTS: "Alerts",
    ABSENCE_MONITORING_LEVEL_ALERTS_PLACEHOLDER: "Click to Add Alerts for This Level",
    ABSENCE_MONITORING_LEVEL_LM_MOVEMENTS: "LM Movements",
    ABSENCE_MONITORING_LEVEL_LM_MOVEMENTS_PLACEHOLDER: "Click to Add Levels for Line Manager",
    ABSENCE_MONITORING_LEVEL_HR_MOVEMENTS: "HR Movements",
    ABSENCE_MONITORING_LEVEL_HR_MOVEMENTS_PLACEHOLDER: "Click to Add Levels for HR",
    ABSENCE_MONITORING_LEVEL_TASKS: "Tasks",
    ABSENCE_MONITORING_LEVEL_TASKS_PLACEHOLDER: "Click to Add Tasks for This Level",
    ABSENCE_MONITORING_LEVEL_REVIEW_EXPIRY: "Review & Expiry",
    ABSENCE_MONITORING_LEVEL_REVIEW_PERIOD: "Review Period",
    ABSENCE_MONITORING_LEVEL_AUTO_EXPIRE_AFTER: "Auto Expire After",
    ABSENCE_MONITORING_LEVEL_AUTO_EXPIRE_ACTION: "Auto Expire Action",
    ABSENCE_MONITORING_LEVEL_AUTO_EXPIRE_ACTION_PLACEHOLDER: "-- Select Action --",
    ABSENCE_MONITORING_ADD_LEVEL: "Add Level",

    // Special Contacts
    SPECIAL_CONTACTS: "Special Contacts",
    ADD_SPECIAL_CONTACT: "Add Special Contact",
    ADD_SPECIAL_CONTACT_STEP1: "1/3 Special Contact Type",
    ADD_SPECIAL_CONTACT_STEP1_INFO:
      "You can add new custom types in the Custom Special Contact Type section on the parent page.",
    ADD_SPECIAL_CONTACT_STEP2: "2/3 Select Employee",
    ADD_SPECIAL_CONTACT_STEP3: "3/3 Special Hierarchy Scope",
    ALREADY_A_SPECIAL_CONTACT: "Already a Special Contact",
    EDIT_SPECIAL_CONTACT: "Edit Special Contact",
    REMOVE_SPECIAL_CONTACT_MODAL_TITLE: "Remove Special Contact",
    REMOVE_SPECIAL_CONTACT_CONFIRMATION:
      "Are you sure would like to delete {specialContact} special contact?",

    // Special Contact Types
    SPECIAL_CONTACT_TYPE: "Special Contact Type",
    ADD_SPECIAL_CONTACT_TYPE: "Add Special Contact Type",
    RENAME_SPECIAL_CONTACT_TYPE: "Rename Special Contact Type",
    CUSTOM_SPECIAL_CONTACT_TYPES: "Custom Special Contact Types",
    ADD_NEW_TYPE: "Add New Type",
    REMOVE_SPECIAL_CONTACT_TYPE_MODAL_TITLE: "Remove Special Contact Type",
    REMOVE_SPECIAL_CONTACT_TYPE_CONFIRMATION:
      "Are you sure would like to delete {specialContactType} special contact type?",

    //Reporting Parameters
    INCLUDED: "Included",
    EXCLUDED: "Excluded",
    REPORTING_OPTIONS: "Reporting Options",
    LONG_TERM_DEFINITION_DAYS: "Long Term Definition Days",
    LONG_TERM_DEFINITION_TYPE: "Long Term Definition Type",
    REPORTING_PERIODS: "Reporting Periods",
    ABSENCE_RATE_CALCULATION_TYPE: "Absence Rate Calculation Type",
    BRADFORD_SCORE_ENABLED: "Bradford Score Enabled",
    BRADFORD_SCORE_ABSENCE_TYPE: "Bradford Score Absence Type",
    BRADFORD_SCORE_DAY_TYPE: "Bradford Score Day Type",
    BRADFORD_SCORE_PERIOD_MONTHS: "Bradford Score Period (Months)",
    BV12_TREND_AVAILABLE: "BV12 Trend Available",
    SALARY_COST_ABSENCE_TREND: "Salary Cost of Absence Trend",
    EMPLOYEE_ABSENCE_RATES: "Employee Absence Rates",
    PHASED_RTW_INCLUDED_ABSENCE_RATES: "Phased RTW Included in Absence Rates",
    TREND_ASSUMPTIONS: "Trend Assumptions",
    HISTORICAL_DATA_UNDER_REPORTING: "Historical Data Under-Reporting %",
    DESCRIPTION_DATA_REASON_SUSPECTED_UNDER_REPORTING:
      "Description of Reason for Suspected Under Reporting",
    ESTIMATED_DATA_COST_ABSENCE: "Estimated Daily Cost of Absence",
    DESCRIPTION_REASON_COST_ABSENCE: "Description of Reason for Cost of Absence",
    DESCRIPTION_REASON_SUSPECTED_UNDER_REPORTING: "Description Reason Suspected Under Reporting",
    ESTIMATED_DAILY_COST_ABSENCE: "Estimated Daily Cost of Absence",
    WORKING: "Working",
    CALENDAR: "Calendar",
    CALENDAR_MONTH: "Calendar Month",
    "4_4_5_WEEKS": "4, 4, 5 Weeks",
    CALENDAR_DAYS: "Calendar Days",
    FTE_CALENDAR_DAYS: "Fte Calendar Days",
    WORKING_DAYS: "Working Days",
    WORKING_HOURS: "Working Hours",
    WORKING_HOURS_LOST: "Working Hours Lost",
    WORKING_DAYS_LOST: "Working Days Lost",
    WORKING_HOURS_ABSENCE_RATE: "Working hours absence rate",
    HOURS_AVAILABLE: "Hours available",
    CALENDAR_DAYS_LOST: "Calendar Days Lost",
    RTW_COMPLIANCE: "RTW Compliance",
    REASONS_TO_BE_EXCLUDED: "Reasons to Be Excluded",
    REASONS_TO_BE_EXCLUDED_FROM_BRATFORD_SCORES: "Reasons to be Excluded from Bradford Scores",

    ADD_REASON_TO_BE_EXCLUDED: "Add Reason to be Excluded from Bradford Scores",
    EDIT_REASON_TO_BE_EXCLUDED: "Edit Reason to be Excluded from Bradford Scores",
    ABSENCE_REASON_NOT_INCLUDED: "Absence Reason Not Included in Absence Rates",
    DATE_EXCLUDE_FROM: "Date Excluded From",
    DATE_EXCLUDE_TO: "Date Excluded To",
    OPTIONS_AND_TREND_ASSUMPTIONS: "Options and Trend Assumptions",
    EDIT_REPORTING_OPTIONS: "Edit Reporting Options",
    EDIT_TREND_ASSUMPTIONS: "Edit Trend Assumptions",
    SELECT_ABSENCE_REASON: "Select Absence Reason",
    NUMBER_RECORDS_SELECTED: "{number} records selected",
    DELETE_REASON_TO_BE_EXCLUDED_MODAL_TITLE: "Delete Reason To Be Excluded",
    DELETE_REASON_TO_BE_EXCLUDED_CONFIRMATION:
      "Are you sure would like to delete {reason} reason to be excluded?",
    DELETE_REASONS_TO_BE_EXCLUDED_CONFIRMATION:
      "Are you sure would like to delete selected reasons to be excluded?",
    TARGET_ABSENCE_RATE: "Target Absence Rate",

    // Service Summary
    SERVICE_SUMMARY_NOTIFICATION_TEXT_1:
      "Please note that service configuration updates are applied once a day at 10:00pm.",
    SERVICE_SUMMARY_NOTIFICATION_TEXT_2:
      "Any changes you make to the system (excluding those that are still pending GoodShape approval) will be applied at this time.",
    RECENT_REVIEWS: "Recent Reviews",
    DRAFTS_IN_PROGRESS: "Drafts In Progress",
    CHANGES_LAST_30_DAYS: "Changes Last 30 Days",
    APPROVED: "Approved",
    BLOCKED: "Blocked",
    DEFERRED: "Deferred",
    COMPLETED_CHANGES: "Completed Changes",
    DELETE_CHANGE_SET_MODAL_TITLE: "Delete Change Set",
    DELETE_CHANGE_SET_CONFIRMATION: "Are you sure would like to delete {reason} change set?",
    DELETE_CHANGE_SETS_CONFIRMATION: "Are you sure would like to delete selected change sets?",
    CHANGE_SET_FILTER_FROM_DATE: "From Date",
    CHANGE_SET_FILTER_TO_DATE: "To Date",

    // Dynamic Questions
    CALL_SCRIPTING: "Call Scripting",
    DYNAMIC_QUESTIONS_LIVE: "Live Dynamic Questions",
    DYNAMIC_QUESTIONS_LIVE_FC: "Live Dynamic Questions FC",
    DYNAMIC_QUESTIONS_LIVE_EMPTY: "No Live Dynamic Questions to review",
    DYNAMIC_QUESTIONS_LIVE_EMPTY_FC: "No Live Dynamic Questions to review",
    DYNAMIC_QUESTIONS_PENDING_REVIEW: "Dynamic Questions Pending Review",
    DYNAMIC_QUESTIONS_PENDING_REVIEW_FC: "Dynamic Questions Pending Review FC",
    DYNAMIC_QUESTIONS_PENDING_REVIEW_EMPTY: "No Pending Dynamic Questions to review",
    DYNAMIC_QUESTIONS_PENDING_REVIEW_EMPTY_FC: "No Pending Dynamic Questions to review",
    DYNAMIC_QUESTIONS_DRAFT_FC: "Dynamic Questions Drafts FC",
    DYNAMIC_QUESTIONS_DRAFT: "Dynamic Questions Drafts",
    DYNAMIC_QUESTIONS_DRAFT_EMPTY: "No Draft Dynamic Questions to review",
    DYNAMIC_QUESTIONS_DRAFT_EMPTY_FC: "No Draft Dynamic Questions to review",
    QUESTION_TEXT: "Question Text",
    QUESTION_TYPE: "Question Type",
    ADVISOR_TYPE: "Advisor Type",
    ADVISOR_TYPE_TOOLTIP:
      "Use this field to determine whether the question is to be asked by either an Absence Advisor or a Nurse Advisor.",
    IS_ACTIVE_TOOLTIP:
      "Use this field to alter the status of a standard question. Questions can be set to being either 'active' or 'inactive'.",
    MANDATORY: "Mandatory",
    START_NOTIFICATION: "Start Notification",
    UPDATE_NOTIFICATION: "Update Notification",
    CLOSE_NOTIFICATION: "Close Notification",
    START_DYNAMIC_QUESTION_DRAFT: "Start Dynamic Question Draft",
    ADD_DYNAMIC_QUESTION: "Add Dynamic Question",
    DYNAMIC_QUESTION_ACTION_START_DRAFT: "Start Dynamic Question Draft",
    DYNAMIC_QUESTION_ACTION_VIEW_CURRENT_DRAFT: "View Current Dynamic Question Draft",
    DYNAMIC_QUESTION_ACTION_EDIT_HIERARCHY_SCOPE: "Edit Hierarchy Scope",
    DYNAMIC_QUESTION_ACTION_DUPLICATE_SETUP: "Duplicate Dynamic Question",
    DYNAMIC_QUESTION_ACTION_DISABLE_SETUP: "Disable Dynamic Question",
    DYNAMIC_QUESTION_ACTION_CANCEL_REVIEW_AND_RESUME_EDIT: "Cancel Review and Resume Editing",
    DYNAMIC_QUESTION_ACTION_CANCEL_REVIEW_AND_DISCARD_DRAFT: "Cancel Review and Discard Draft",
    DYNAMIC_QUESTION_ACTION_EDIT_REASON_SPECIFIC_USAGE: "Edit Reason Specific Usage",
    DYNAMIC_QUESTION_ACTION_DISCARD_DRAFT: "Discard Draft",
    DYNAMIC_QUESTION_ACTION_EDIT_LENGTH_SCOPE: "Edit Length Scope",
    DYNAMIC_QUESTION_ACTION_EDIT_ANSWER_OPTIONS: "Edit Answer Options",
    DYNAMIC_QUESTION_ACTION_EDIT_QUESTION_TYPE: "Edit Question Type",
    PENDING_REVIEW: "Pending Review",
    PENDING_REVIEW_FC: "Pending Review",
    ADD_DYNAMIC_QUESTION_MODAL_TITLE_FC: "Add New Question",
    ADD_DYNAMIC_QUESTION_MODAL_TITLE: "Add New Question",
    ADD_QUESTION_MODAL_STEP_1_TITLE: "{step}/{totalSteps} Question Type",
    ADD_QUESTION_MODAL_STEP_2_TITLE: "{step}/{totalSteps} Hierarchy Scope",
    ADD_QUESTION_MODAL_STEP_3_TITLE: "{step}/{totalSteps} Reason Scope",
    ADD_QUESTION_MODAL_STEP_4_TITLE: "{step}/{totalSteps} Length Scope",
    ADD_QUESTION_MODAL_STEP_5_TITLE: "{step}/{totalSteps} Answer Options",
    ADD_QUESTION_MODAL_STEP_1_NEXT_BUTTON: "Next Hierarchy Scope",
    ADD_QUESTION_MODAL_STEP_2_NEXT_BUTTON: "Next Reason Scope",
    ADD_QUESTION_MODAL_STEP_3_NEXT_BUTTON: "Next Length Scope",
    ADD_QUESTION_MODAL_STEP_4_NEXT_BUTTON: "Next Answer Options",
    ADD_QUESTION_MODAL_STEP_4_SAVE_BUTTON: "Save Length Scope",
    ADD_QUESTION_MODAL_STEP_5_NEXT_BUTTON: "Save Answer Options",
    ANSWER_OPTION: "Answer Option",
    ADD_ANSWER_OPTION: "Add Answer Option",
    REASON_RESTRICTION: "Reason Restriction",
    HIERARCHY_RESTRICTION: "Hierarchy Restriction",
    DURATION_DAYS: "Duration Days",
    DYNAMIC_QUESTION_DETAILS: "Dynamic Question #{providerId}",
    DYNAMIC_QUESTION_DRAFT: "Draft for Dynamic Question #{providerId}",
    DYNAMIC_QUESTION_LAST_UPDATED_BY: "Last edited by:",
    EDIT_CURRENT_DRAFT: "Edit Current Draft",
    CANCEL_REVIEW: "Cancel Review",
    DYNAMIC_QUESTION_DETAILS_QUESTION_TYPE: "Question Type",
    DYNAMIC_QUESTION_DETAILS_REASON_SCOPE: "Reason Scope",
    DYNAMIC_QUESTION_DETAILS_SECTION_EMPTY: "This section has not been completed yet.",
    DYNAMIC_QUESTION_DETAILS_LENGTH_SCOPE: "Length Scope",
    DYNAMIC_QUESTION_DETAILS_ANSWER_OPTIONS: "Answer Options",
    EDIT_DYNAMIC_QUESTION_MODAL_TITLE: "Draft for Dynamic Question #{providerId}",
    EDIT_DYNAMIC_QUESTION_MODAL_TITLE_FC: "Dynamic Question #{providerId}",
    APPROVABLE_TYPE_DYNAMIC: "Question",
    APPROVABLE_TYPE_EAP: "EAP Set-Up",
    APPROVABLE_TYPE_REASON: "Reason",
    ADVISOR_ONLY: "Absence Advisor Only",
    NURSE_ONLY: "Nurse Advisor Only",
    TARGETED: "Targeted",

    // System access
    LOGO: "Logo",
    UPLOAD: "Upload",
    UPLOAD_LOGO: "Upload Logo",
    NO_LOGO_PROVIDED: "No logo provided",
    PASSWORD_RESET: "Password Reset",
    PASSWORD_RESET_REQUIREMENT: "Password Reset Requirement",
    PASSWORD_RESET_REQUIREMENT_MANAGERS: "Managers Are Required to Reset Password",
    PASSWORD_RESET_REQUIREMENT_EMPLOYEES: "Employees Are Required to Reset Password",
    EVERY_X_DAYS: "Every {days} days",
    INACTIVITY_IN_MINUTES: "{minutes} minutes of Inactivity",
    FAILED_LOGIN_ATTEMPTS: "{times} Failed Login Attempts",
    LOG_OUT_AND_LOCK: "Log Out and Lock",
    LOG_OUT_USER_AFTER: "Log Out User Automatically After",
    LOCK_USER_AFTER: "Lock User Account After",
    ADD_IP_RESTRICTION: "Add IP Restriction",
    IP_ADDRESS_RESTRICTION_ENABLED: "IP Address Restriction Enabled",
    IP_ADDRESS_RESTRICTION_DISABLED: "IP Address Restriction Disabled",
    RECORDS_SELECTED: "{numberOfRecords} records selected",
    DEFAULT_INTRODUCTION_TEXT: "Default Introduction Text",
    FULL_HR_ACCESS_INTRODUCTION_TEXT: "Full HR Access Introduction Text",
    LINE_MANAGER_INTRODUCTION_TEXT: "Line Manager Introduction Text",
    ADVANCED_USER_INTRODUCTION_TEXT: "Advanced User Introduction Text",
    EMPLOYEE_INTRODUCTION_TEXT: "Employee Introduction Text",
    EDIT_STANDARD_REGISTRATION_EMAILS: "Edit Standard Registration Emails",

    // Default Standard Scripts
    DEFAULT_STANDARD_SCRIPTS: "Default Standard Scripts",
    DEFAULT_STANDARD_SCRIPTS_LIVE_FC: "Live Default Standard Scripts FC",
    DEFAULT_STANDARD_SCRIPTS_LIVE: "Live Default Standard Scripts",
    DEFAULT_STANDARD_SCRIPTS_LIVE_EMPTY_FC: "No Live Default Standard Scripts to review",
    DEFAULT_STANDARD_SCRIPTS_LIVE_EMPTY: "No Live Default Standard Scripts to review",
    DEFAULT_STANDARD_SCRIPTS_PENDING_REVIEW_FC: "Default Standard Scripts Pending Review FC",
    DEFAULT_STANDARD_SCRIPTS_PENDING_REVIEW: "Default Standard Scripts Pending Review",
    DEFAULT_STANDARD_SCRIPTS_PENDING_REVIEW_EMPTY_FC:
      "No Pending Default Standard Scripts to review",
    DEFAULT_STANDARD_SCRIPTS_PENDING_REVIEW_EMPTY: "No Pending Default Standard Scripts to review",
    DEFAULT_STANDARD_SCRIPTS_DRAFT_FC: "Default Standard Scripts Drafts FC",
    DEFAULT_STANDARD_SCRIPTS_DRAFT: "Default Standard Scripts Drafts",
    DEFAULT_STANDARD_SCRIPTS_DRAFT_EMPTY_FC: "No Draft Default Standard Scripts to review",
    DEFAULT_STANDARD_SCRIPTS_DRAFT_EMPTY: "No Draft Default Standard Scripts to review",
    SCRIPT_TYPE: "Script Type",
    SCRIPT_TEXT: "Script Text",
    SAVE_STANDARD_SCRIPT: "Save",
    DEFAULT_STANDARD_SCRIPT_ACTION_START_DRAFT: "Start Default Standard Script Draft",
    DEFAULT_STANDARD_SCRIPT_ACTION_VIEW_CURRENT_DRAFT: "View Current Default Standard Script Draft",
    DEFAULT_STANDARD_SCRIPT_ACTION_DISABLE_SETUP: "Disable Default Standard Script",
    DEFAULT_STANDARD_SCRIPT_ACTION_CANCEL_REVIEW_AND_RESUME_EDIT:
      "Cancel Review and Resume Editing",
    DEFAULT_STANDARD_SCRIPT_ACTION_CANCEL_REVIEW_AND_DISCARD_DRAFT:
      "Cancel Review and Discard Draft",
    DEFAULT_STANDARD_SCRIPT_ACTION_EDIT_SCRIPT_TEXT: "Edit Script Text",
    DEFAULT_STANDARD_SCRIPT_SCRIPT_TEXT: "Edit Script Text",
    DEFAULT_STANDARD_SCRIPT_ACTION_DISCARD_DRAFT: "Discard Draft",
    APPROVABLE_TYPE_DEFAULT_STANDARD_SCRIPT: "Default Script",
    DEFAULT_STANDARD_SCRIPT_DETAILS: "Default Standard Script #{providerId}",
    DEFAULT_STANDARD_SCRIPT_DRAFT: "Draft for Default Standard Script #{providerId}",
    DEFAULT_STANDARD_SCRIPT_LAST_UPDATED_BY: "Last edited by:",
    DEFAULT_STANDARD_SCRIPT_START_DRAFT: "Start Draft",
    DEFAULT_STANDARD_SCRIPT_DETAILS_LOCKED_PENDING_REVIEW:
      "This draft is locked and cannot be edited as it is pending review.",
    DEFAULT_STANDARD_SCRIPT_DETAILS_SECTION_EMPTY: "This section has not been completed yet.",
    DRAFT_FOR_SCRIPT: "Draft for {scriptName}",
    MAIN_DETAILS: "Main Details",
    LOCKED_DEPENDENCIES: "This section is locked and cannot be edited due to a dependency.",

    // Department Specific Scripts
    DEPARTMENT_SPECIFIC_SCRIPTS: "Department Specific Scripts",
    DEPARTMENT_SCRIPTS: "Department Scripts",
    REASON_SCRIPTS: "Reason Scripts",
    HIERARCHY_AREAS: "Hieararchy areas",
    DEPARTMENT_SPECIFIC_SCRIPTS_LIVE_FC: "Live Department Specific Scripts FC",
    DEPARTMENT_SPECIFIC_SCRIPTS_LIVE: "Live Department Specific Scripts",
    ADD_DEPARTMENT_SPECIFIC_SCRIPT: "Add Department Specific Script",
    DEPARTMENT_SPECIFIC_SCRIPTS_LIVE_EMPTY_FC: "No Live Department Specific Scripts to review",
    DEPARTMENT_SPECIFIC_SCRIPTS_LIVE_EMPTY: "No Live Department Specific Scripts to review",
    DEPARTMENT_SPECIFIC_SCRIPTS_PENDING_REVIEW_FC: "Department Specific Scripts Pending Review FC",
    DEPARTMENT_SPECIFIC_SCRIPTS_PENDING_REVIEW: "Department Specific Scripts Pending Review",
    DEPARTMENT_SPECIFIC_SCRIPTS_PENDING_REVIEW_EMPTY_FC:
      "No Pending Department Specific Scripts to review",
    DEPARTMENT_SPECIFIC_SCRIPTS_PENDING_REVIEW_EMPTY:
      "No Pending Department Specific Scripts to review",
    DEPARTMENT_SPECIFIC_SCRIPTS_DRAFT_FC: "Department Specific Scripts Drafts FC",
    DEPARTMENT_SPECIFIC_SCRIPTS_DRAFT: "Department Specific Scripts Drafts ",
    DEPARTMENT_SPECIFIC_SCRIPTS_DRAFT_EMPTY: "No Draft Department Specific Scripts to review",
    DEPARTMENT_SPECIFIC_SCRIPTS_DRAFT_EMPTY_FC: "No Draft Department Specific Scripts to review",
    ADD_DEPARTMENT_SPECIFIC_SCRIPT_MODAL_TITLE_FC: "Add Department Specific Script",
    ADD_DEPARTMENT_SPECIFIC_SCRIPT_MODAL_TITLE: "Add Department Specific Script",
    ADD_DEPARTMENT_SPECIFIC_SCRIPT_STEP_1_TITLE: "Main Details",
    ADD_DEPARTMENT_SPECIFIC_SCRIPT_MODAL_STEP_2_TITLE: "Hierarchy Area",
    ADD_DEPARTMENT_SPECIFIC_SCRIPT_STEP_1_NEXT_BUTTON: "Next: Hierarchy Area",
    DEPARTMENT_SPECIFIC_SCRIPT_SAVE_DRAFT: "Save Draft",
    DEPARTMENT_SPECIFIC_SCRIPT_ACTION_START_DRAFT: "Start Department Specific Script Draft",
    DEPARTMENT_SPECIFIC_SCRIPT_ACTION_VIEW_CURRENT_DRAFT:
      "View Current Department Specific Script Draft",
    DEPARTMENT_SPECIFIC_SCRIPT_ACTION_EDIT_HIERARCHY_SCOPE: "Edit Hierarchy Scope",
    DEPARTMENT_SPECIFIC_SCRIPT_ACTION_DUPLICATE_SETUP: "Duplicate Department Specific Script",
    DEPARTMENT_SPECIFIC_SCRIPT_ACTION_DISABLE_SETUP: "Disable Department Specific Script",
    DEPARTMENT_SPECIFIC_SCRIPT_ACTION_CANCEL_REVIEW_AND_RESUME_EDIT:
      "Cancel Review and Resume Editing",
    DEPARTMENT_SPECIFIC_SCRIPT_ACTION_CANCEL_REVIEW_AND_DISCARD_DRAFT:
      "Cancel Review and Discard Draft",
    DEPARTMENT_SPECIFIC_SCRIPT_ACTION_EDIT_MAIN_DETAILS: "Edit Main Details",
    DEPARTMENT_SPECIFIC_SCRIPT_ACTION_DISCARD_DRAFT: "Discard Draft",
    APPROVABLE_TYPE_DEPARTMENT_SPECIFIC_SCRIPT: "Department Script",
    SAVE_DRAFT_DEPARTMENT_SPECIFIC_SCRIPT: "Save Draft",
    SAVE_DEPARTMENT_SPECIFIC_SCRIPT: "Save",
    EDIT_DEPARTMENT_SPECIFIC_SCRIPT_HIERARCHY_SCOPE_MODAL_TITLE_FC:
      "Hierarchy Scope for Department Specific Script",
    EDIT_DEPARTMENT_SPECIFIC_SCRIPT_HIERARCHY_SCOPE_MODAL_TITLE:
      "Hierarchy Scope for Department Specific Script",
    EDIT_DEPARTMENT_SPECIFIC_SCRIPT: "Edit Department Specific Script",
    DEPARTMENT_SPECIFIC_SCRIPT_DETAILS: "Department Specific Script #{providerId}",
    DEPARTMENT_SPECIFIC_SCRIPT_DRAFT: "Draft #{providerId}",
    DEPARTMENT_SPECIFIC_SCRIPT_LAST_UPDATED_BY: "Last edited by:",
    DEPARTMENT_SPECIFIC_SCRIPT_DETAILS_LOCKED_PENDING_REVIEW:
      "This draft is locked and cannot be edited as it is pending review.",
    DEPARTMENT_SPECIFIC_SCRIPT_DETAILS_SECTION_EMPTY: "This section has not been completed yet.",
    DEPARTMENT_SPECIFIC_SCRIPT_DETAILS_LIVE_DATA_BANNER:
      "Following Below Is Live Data Associated with This Department Specific Script!",
    DETAILS_LIVE_DATA_BANNER_ADDITIONAL:
      "Note: Editing this data is outside the draft-review process and updates will take effect immediately.",
    DETAILS_HIERARCHY_SCOPE: "Hierarchy Scope",
    DETAILS_SECTION_EMPTY: "This section has not been completed yet.",
    DRAFT_FOR_NAME: "Draft for {name}",

    // Reason Specific Scripts
    REASON_SPECIFIC_SCRIPTS: "Reason Specific Scripts",
    REASON_SPECIFIC_SCRIPTS_LIVE_FC: "Live Reason Specific Scripts FC",
    REASON_SPECIFIC_SCRIPTS_LIVE: "Live Reason Specific Scripts",
    ADD_REASON_SPECIFIC_SCRIPT: "Add Reason Specific Script",
    REASON_SPECIFIC_SCRIPTS_LIVE_EMPTY_FC: "No Live Reason Specific Scripts to review",
    REASON_SPECIFIC_SCRIPTS_LIVE_EMPTY: "No Live Reason Specific Scripts to review",
    REASON_SPECIFIC_SCRIPTS_PENDING_REVIEW_FC: "Reason Specific Scripts Pending Review FC",
    REASON_SPECIFIC_SCRIPTS_PENDING_REVIEW: "Reason Specific Scripts Pending Review",
    REASON_SPECIFIC_SCRIPTS_PENDING_REVIEW_EMPTY_FC: "No Pending Reason Specific Scripts to review",
    REASON_SPECIFIC_SCRIPTS_PENDING_REVIEW_EMPTY: "No Pending Reason Specific Scripts to review",
    REASON_SPECIFIC_SCRIPTS_DRAFT_FC: "Reason Specific Scripts Drafts FC",
    REASON_SPECIFIC_SCRIPTS_DRAFT: "Reason Specific Scripts Drafts ",
    REASON_SPECIFIC_SCRIPTS_DRAFT_EMPTY: "No Draft Reason Specific Scripts to review",
    REASON_SPECIFIC_SCRIPTS_DRAFT_EMPTY_FC: "No Draft Reason Specific Scripts to review",
    ADD_REASON_SPECIFIC_SCRIPT_MODAL_TITLE_FC: "Add Reason Specific Script",
    ADD_REASON_SPECIFIC_SCRIPT_MODAL_TITLE: "Add Reason Specific Script",
    ADD_REASON_SPECIFIC_SCRIPT_STEP_1_TITLE: "Main Details",
    ADD_REASON_SPECIFIC_SCRIPT_MODAL_STEP_2_TITLE: "Hierarchy Area",
    ADD_REASON_SPECIFIC_SCRIPT_STEP_1_NEXT_BUTTON: "Next: Hierarchy Area",
    REASON_SPECIFIC_SCRIPT_SAVE_DRAFT: "Save Draft",
    REASON_SPECIFIC_SCRIPT_ACTION_START_DRAFT: "Start Reason Specific Script Draft",
    REASON_SPECIFIC_SCRIPT_ACTION_VIEW_CURRENT_DRAFT: "View Current Reason Specific Script Draft",
    REASON_SPECIFIC_SCRIPT_ACTION_EDIT_HIERARCHY_SCOPE: "Edit Hierarchy Scope",
    REASON_SPECIFIC_SCRIPT_ACTION_DUPLICATE_SETUP: "Duplicate Reason Specific Script",
    REASON_SPECIFIC_SCRIPT_ACTION_DISABLE_SETUP: "Disable Reason Specific Script",
    REASON_SPECIFIC_SCRIPT_ACTION_CANCEL_REVIEW_AND_RESUME_EDIT: "Cancel Review and Resume Editing",
    REASON_SPECIFIC_SCRIPT_ACTION_CANCEL_REVIEW_AND_DISCARD_DRAFT:
      "Cancel Review and Discard Draft",
    REASON_SPECIFIC_SCRIPT_ACTION_EDIT_MAIN_DETAILS: "Edit Main Details",
    REASON_SPECIFIC_SCRIPT_ACTION_DISCARD_DRAFT: "Discard Draft",
    APPROVABLE_TYPE_REASON_SPECIFIC_SCRIPT: "Reason Script",
    SAVE_DRAFT_REASON_SPECIFIC_SCRIPT: "Save Draft",
    SAVE_REASON_SPECIFIC_SCRIPT: "Save",
    EDIT_REASON_SPECIFIC_SCRIPT_HIERARCHY_SCOPE_MODAL_TITLE_FC:
      "Hierarchy Scope for Reason Specific Script",
    EDIT_REASON_SPECIFIC_SCRIPT_HIERARCHY_SCOPE_MODAL_TITLE:
      "Hierarchy Scope for Reason Specific Script",
    EDIT_REASON_SPECIFIC_SCRIPT: "Edit Reason Specific Script",
    REASON_SPECIFIC_SCRIPT_DETAILS: "Reason Specific Script #{providerId}",
    REASON_SPECIFIC_SCRIPT_DRAFT: "Draft #{providerId}",
    REASON_SPECIFIC_SCRIPT_LAST_UPDATED_BY: "Last edited by:",
    REASON_SPECIFIC_SCRIPT_DETAILS_LOCKED_PENDING_REVIEW:
      "This draft is locked and cannot be edited as it is pending review.",
    REASON_SPECIFIC_SCRIPT_DETAILS_SECTION_EMPTY: "This section has not been completed yet.",
    REASON_SPECIFIC_SCRIPT_DETAILS_LIVE_DATA_BANNER:
      "Following Below Is Live Data Associated with This Reason Specific Script!",
    SCRIPT_NAME: "Script Name",

    // Standard Questions
    STANDARD_QUESTION: "Standard Question",
    STANDARD_QUESTIONS_LIVE: "Live Standard Questions",
    STANDARD_QUESTIONS_LIVE_EMPTY: "No Live Standard Questions to review",
    STANDARD_QUESTIONS_LIVE_EMPTY_FC: "No Live Standard Questions to review",
    STANDARD_QUESTIONS_PENDING_REVIEW: "Standard Questions Pending Review",
    STANDARD_QUESTIONS_PENDING_REVIEW_EMPTY: "No Pending Standard Questions to review",
    STANDARD_QUESTIONS_PENDING_REVIEW_EMPTY_FC: "No Pending Standard Questions to review",
    STANDARD_QUESTIONS_DRAFT: "Standard Questions Drafts",
    STANDARD_QUESTIONS_DRAFT_EMPTY: "No Draft Standard Questions to review",
    STANDARD_QUESTIONS_DRAFT_EMPTY_FC: "No Draft Standard Questions to review",
    START_STANDARD_QUESTION_DRAFT: "Start Draft",
    ADD_STANDARD_QUESTION: "Add Standard Question",
    STANDARD_QUESTION_ACTION_START_DRAFT: "Start Draft",
    STANDARD_QUESTION_ACTION_VIEW_CURRENT_DRAFT: "View Current Standard Question Draft",
    STANDARD_QUESTION_ACTION_EDIT_HIERARCHY_SCOPE: "Edit Hierarchy Scope",
    STANDARD_QUESTION_ACTION_DUPLICATE_SETUP: "Duplicate Standard Question",
    STANDARD_QUESTION_ACTION_DISABLE_SETUP: "Disable Standard Question",
    STANDARD_QUESTION_ACTION_CANCEL_REVIEW_AND_RESUME_EDIT: "Cancel Review and Resume Editing",
    STANDARD_QUESTION_ACTION_CANCEL_REVIEW_AND_DISCARD_DRAFT: "Cancel Review and Discard Draft",
    STANDARD_QUESTION_ACTION_EDIT_REASON_SPECIFIC_USAGE: "Edit Reason Specific Usage",
    STANDARD_QUESTION_ACTION_DISCARD_DRAFT: "Discard Draft",
    STANDARD_QUESTION_ACTION_EDIT_LENGTH_SCOPE: "Edit Length Scope",
    STANDARD_QUESTION_ACTION_EDIT_ANSWER_OPTIONS: "Edit Answer Options",
    STANDARD_QUESTION_ACTION_EDIT_QUESTION_TYPE: "Edit Question Type",
    ADD_STANDARD_QUESTION_MODAL_TITLE_FC: "Add New Question",
    ADD_STANDARD_QUESTION_MODAL_TITLE: "Add New Question",
    STANDARD_QUESTION_DETAILS: "Standard Question - {name}",
    STANDARD_QUESTION_DRAFT: "Draft for {name}",
    STANDARD_QUESTION_LAST_UPDATED_BY: "Last edited by:",
    STANDARD_QUESTION_DETAILS_QUESTION_TYPE: "Question Type",
    STANDARD_QUESTION_DETAILS_REASON_SCOPE: "Reason Scope",
    STANDARD_QUESTION_DETAILS_SECTION_EMPTY: "This section has not been completed yet.",
    STANDARD_QUESTION_DETAILS_LENGTH_SCOPE: "Length Scope",
    STANDARD_QUESTION_DETAILS_ANSWER_OPTIONS: "Answer Options",
    EDIT_STANDARD_QUESTION_MODAL_TITLE: "Draft for Standard Question #{providerId}",
    EDIT_STANDARD_QUESTION_MODAL_TITLE_FC: "Standard Question #{providerId}",
    APPROVABLE_TYPE_STANDARD: "Standard Question",
    SAVE_DRAFT_STANDARD_QUESTION: "Save Draft",
    SAVE_STANDARD_QUESTION: "Save",
    STANDARD_QUESTION_ACTION_EDIT_MAIN_DETAILS: "Edit Main Details",
    STANDARD_QUESTION_DETAILS_LOCKED_PENDING_REVIEW:
      "This draft is locked and cannot be edited as it is pending review.",
    STANDARD_QUESTION_DETAILS_LIVE_DATA_BANNER:
      "Following Below Is Live Data Associated with This Standard Question!",
    STANDARD_QUESTION_DETAILS_MAIN_DETAILS: "Main Details",
    ADD_STANDARD_QUESTION_MODAL_STEP_1_TITLE: "Main Details",
    ADD_STANDARD_QUESTION_MODAL_STEP_2_TITLE: "Hierarchy scope",
    ADD_STANDARD_QUESTION_MODAL_STEP_2_TITLE_TOOLTIP:
      "Use this tool to select which area(s) within your organisation's hierarchy your standard question will apply to. This is done by ticking the name of the desired location(s). Your chosen areas will appear under the column title 'Areas Included', whilst areas you may choose to deselect (i.e. those outside desired scope) will appear under the column title 'Areas Excluded'. Your standard question applies only to areas which are listed under the 'Areas Included' column. Note that 'child' units are included when a 'parent' is selected to be within scope.",
    ALL: "All",

    ONE_PER_ABSENCE: "One per Absence",
    ALL_FULL_CONTACTS: "All full contacts",
    ALL_REASONS: "All reasons",
    ONE_PER_ROLE: "One per role",
    RTW_CONTACTS_OF_ABSENCE_ONLY: "RTW contacts of absence only",

    // REFERRAL SUPPLIER DETAILS
    SUPPLIER_ID: "Supplier ID",
    SUPPLIER_NAME: "Supplier Name",
    SUPPLIER_DESCRIPTION: "Supplier Description",
    EMAIL_ADDRESS: "Email Address",
    SERVICE_PROVIDED: "Service Provided",
    MANAGER_REFERRALS: "Manager Referrals",
    EMPLOYEE_REFERRALS: "Employee Referrals",

    EMAILS: "Emails",
    MANAGERS_HR_REGISTRATIONS: "Managers & HR Registrations",
    BULK_REGISTRATIONS_TEXT:
      'There are <u><strong class="text-pumpkin-orange pointer">{count}</strong></u> full notification contacts who do not have an active GoodShapeCentral account.',
    SEND_BULK_EMAILS: "Send Bulk Registration Emails",
    SEND_BULK_EMAILS_CONFIRM: "Yes, Send Bulk Emails",
    SEND_BULK_EMAILS_TEXT1:
      "This will create and issue {count} GoodShapeCentral registration emails (one for each Full Notification contact without an existing account).",
    SEND_BULK_EMAILS_TEXT2: "Are you sure you wish to continue?",
    EMPLOYEE_REGISTRATIONS: "Employee Registrations",
    EMPLOYEE_REGISTRATIONS_TEXT:
      'There are <u><strong class="text-pumpkin-orange pointer">{count}</strong></u> employees who do not have an active GoodShapeCentral account.',
    SEND_EMPLOYEE_EMAILS: "Send Employee Registration Emails",
    SEND_EMPLOYEE_EMAILS_TEXT1:
      "This will create and issue {count} GoodShapeCentral registration emails (one for each Employee without an existing account).",
    STANDARD_REGISTRATION_EMAILS: "Standard Registration Emails",
    SECTION_LOCKED: "This section is locked and cannot be edited due to pending {name} changes.",
    ANY: "Any",
    UPDATES_BATCHED_TOGETHER: "Updates batched together",
    NO_DUPLICATING_REASONS: "No duplicating reasons",
    EXCLUDE: "Exclude",
    REVIEW_BULK_REGISTRATION_ADDRESSES: "Review Bulk Registration Addresses",
    STEP_1_OF_2_SELECT_EMPLOYEE: "1/2 Select Employee",
    STEP_2_OF_2_HIERARCHY_SCOPE: "2/2 Hierarchy Scope",
    SCHEDULED_REPORTS: "Scheduled Reports",
    SCHEDULED_REPORT_ACCESS: "Scheduled Report Access",
    OCCURRENCES: "Occurrences",
    AUTO_DISABLING: "Auto-disabling",
    REPORTS_EXPIRY: "Reports Expiry",
    INACTIVE_REASON_LABEL: "!! Inactive !!",
    ENABLE_SCHEDULED_REPORTS_BUTTON: "Yes, Enable Scheduled Reports",
    ENABLE_SCHEDULED_REPORTS_WARNING: "Are you sure want to enable Scheduled Reports?",
    ENABLE_SCHEDULED_REPORTS_WARNING_TEXT_1:
      "The security and confidentiality of your employee's personal information is of paramount importance to GoodShape. As such, we want to bring to your attention that, by enabling scheduled reports, your users will be able to access confidential information without the need to authenticate via a username, password or valid IP address.",
    ENABLE_SCHEDULED_REPORTS_WARNING_TEXT_2:
      "This is because links to download reports will be sent directly to the users mailbox, by-passing their need to login to the system. If this is an accepted and understood process then you can finish enabling Scheduled Reports using the button below. However, if you are uncertain about whether or not to proceed we suggest pressing the Cancel button and consulting with your Information Governance team.",
    CHARS_LEFT: `<strong class="text-color-pumpkin-orange">{count}</strong> Characters Left`,
    APP_STATUS: "App Status",
    ONBOARDED: "Onboarded",
    NOT_ONBOARDED: "Not Onboarded",
    DATE_ONBOARDED: "Date Onboarded",
    SUPPORT_PROVIDES: "{name} provides support for",
  },
};
